/** Arabic for the executive desks: cash, capital projects, crisis, regulatory, expansion, improvement, benchmark, green and the finance ledger. Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  "{site} · Executive": "{site} · الإدارة التنفيذية",
  "demo / entered": "تجريبي / مُدخَل",
  "The line for the board": "الخلاصة لمجلس الإدارة",
  "What this desk does not cover": "ما لا يغطيه هذا المكتب",
  "so the reader knows what is absent": "ليعرف القارئ ما هو غائب",
  "written from the figures; a connected model may argue and is checked against them":
    "مكتوبة من الأرقام؛ يجوز لنموذج متصل أن يعترض، ويُتحقَّق من كلامه مقابلها",
  "written from the records; a connected model may argue and is checked against them":
    "مكتوبة من السجلات؛ يجوز لنموذج متصل أن يعترض، ويُتحقَّق من كلامه مقابلها",
  "Revenue, cost and budget by month": "الإيرادات والتكلفة والميزانية حسب الشهر",
  "{month}: revenue {revenue}, cost {cost}, budget {budget}":
    "{month}: الإيرادات {revenue}، التكلفة {cost}، الميزانية {budget}",
  "The model's challenge was withheld: it stated a figure the module did not produce ({list}).":
    "حُجب اعتراض النموذج: ذكر رقمًا لم تنتجه الوحدة ({list}).",
  "The model's challenge was withheld: it stated figures the module did not produce ({list}).":
    "حُجب اعتراض النموذج: ذكر أرقامًا لم تنتجها الوحدة ({list}).",
  "Challenged by {model}; every figure checked against the module.":
    "اعترض عليه {model}؛ وتم التحقق من كل رقم مقابل الوحدة.",
  "The model could not be reached: {error}": "تعذّر الوصول إلى النموذج: {error}",
  "the module": "الوحدة",
  withheld: "محجوب",
  error: "خطأ",
  "The module answers from its own figures — ask about a tile, a candidate, a rank or what to do first. Connect a model in Settings for anything wider.":
    "تجيب الوحدة من أرقامها فقط — اسأل عن بطاقة أو خيار مرشّح أو ترتيب أو عمّا يجب فعله أولًا. اربط نموذجًا من الإعدادات لأي سؤال أوسع.",
  "Withheld: the reply stated figures the module did not produce ({list}).":
    "محجوب: ذكر الرد أرقامًا لم تنتجها الوحدة ({list}).",
  "Ask the model to argue against it": "اطلب من النموذج أن يعترض عليها",
  "No model connected — Settings › Sky › beyond the platform": "لا يوجد نموذج متصل — الإعدادات › سكاي › ما وراء المنصة",
  "Question for {title}": "سؤال إلى {title}",
  "saved on the platform under {who}": "حُفظ على المنصة باسم {who}",
  "saved in this browser only — the platform did not take the note":
    "حُفظ في هذا المتصفح فقط — لم تقبل المنصة الملاحظة",
  "What do we burn a day?": "كم ننفق في اليوم؟",
  "What is on the table?": "ما المطروح على الطاولة؟",
  "Where is the plan missed?": "أين لم تتحقق الخطة؟",
  "What the airport earns and burns each day, where the plan is missed, and what is on the table: cost to cut, revenue to recover, escalation to avoid — each with the record it rests on and the risk of taking it. Revenue and operating cost are the finance system's figures, entered here; what work cost and what deferral costs are the platform's own.":
    "ما يكسبه المطار وما ينفقه كل يوم، وأين لم تتحقق الخطة، وما المطروح على الطاولة: تكلفة يمكن خفضها، وإيرادات يمكن استردادها، وتصاعد في التكلفة يمكن تجنّبه — ولكلٍّ منها السجل الذي يستند إليه ومخاطرة الأخذ به. الإيرادات والإنفاق التشغيلي أرقام النظام المالي تُدخَل هنا؛ أما تكلفة الأعمال وتكلفة التأجيل فهي من المنصة نفسها.",
  "Demonstration figures.": "أرقام توضيحية.",
  "Revenue, cost and capital below are the demonstration’s until the finance system’s are connected. Nothing here is the airport’s.":
    "الإيرادات والتكلفة ورأس المال أدناه أرقام العرض التوضيحي إلى أن تُربط أرقام النظام المالي. لا شيء هنا من أرقام المطار.",
  "Connect the ledger": "ربط دفتر الأستاذ",
  "Revenue, cost and plan by month": "الإيرادات والتكلفة والخطة حسب الشهر",
  "blue revenue, red cost, grey the revenue plan": "الأزرق للإيرادات، والأحمر للتكلفة، والرمادي لخطة الإيرادات",
  "From the plan to the bottom line": "من الخطة إلى صافي الربح",
  "plan net {plan} → actual {actual}": "صافي الخطة {plan} ← الفعلي {actual}",
  "Operating cost by area": "التكلفة التشغيلية حسب المجال",
  "actual against budget for the period": "الفعلي مقابل الميزانية للفترة",
  "No split by area entered.": "لم يُدخَل توزيع حسب المجال.",
  "What work cost on the platform": "تكلفة الأعمال على المنصة",
  "{n} priced work orders — actual against planned": "أوامر العمل المسعّرة: {n} — الفعلي مقابل المخطط",
  "No work order on the platform carries a cost yet.": "لا يحمل أي أمر عمل على المنصة تكلفة بعد.",
  "On the table": "المطروح على الطاولة",
  "cuts, recoveries and escalation avoided, largest first — each with what taking it risks":
    "التخفيضات والاستردادات والتصاعد المُتجنَّب، الأكبر أولًا — ولكلٍّ منها ما يعرّضه الأخذ به للمخاطرة",
  kind: "النوع",
  candidate: "الخيار المرشّح",
  "a year": "في السنة",
  working: "طريقة الحساب",
  risk: "المخاطرة",
  cut: "خفض",
  recover: "استرداد",
  avoid: "تجنّب",
  "Nothing on the table: every line is on plan and no priced work escalates.":
    "لا شيء مطروح: كل بند ضمن الخطة ولا يتصاعد أي عمل مسعّر.",
  "The capital projects have their own screen:": "للمشاريع الرأسمالية شاشتها الخاصة:",
  "The deferred-cost register is at": "سجل تكاليف التأجيل في",
  Liability: "الالتزامات المؤجلة",
  "What do we burn a day? What is on the table? Where is the plan missed?":
    "كم ننفق في اليوم؟ ما المطروح على الطاولة؟ أين لم تتحقق الخطة؟",
  "The finance figures — connect the finance system's ledger, or enter them by hand":
    "الأرقام المالية — اربط دفتر الأستاذ في النظام المالي أو أدخلها يدويًا",
  "{label} revenue over plan": "إيرادات {label} فوق الخطة",
  "{label} revenue under plan": "إيرادات {label} دون الخطة",
  "{label} revenue": "إيرادات {label}",
  "Operating cost under plan": "التكلفة التشغيلية دون الخطة",
  "Operating cost over plan": "التكلفة التشغيلية فوق الخطة",
  "operating cost": "التكلفة التشغيلية",
  "{label} revenue back to plan": "إعادة إيرادات {label} إلى الخطة",
  "{amount} under plan over {days} days, annualised": "{amount} دون الخطة خلال {days} يومًا، محسوبة على أساس سنوي",
  "a plan that was too high in the first place — check the plan before the tenants":
    "خطة كانت مرتفعة أكثر من اللازم من الأساس — راجع الخطة قبل المستأجرين",
  "{label} back to budget": "إعادة {label} إلى الميزانية",
  "{amount} over budget over {days} days, annualised": "{amount} فوق الميزانية خلال {days} يومًا، محسوبة على أساس سنوي",
  "deferred maintenance escalates — the register below prices it":
    "تتصاعد تكلفة الصيانة المؤجلة — والسجل أدناه يسعّرها",
  "service levels and the queue KPI": "مستويات الخدمة ومؤشر KPI لطوابير الانتظار",
  "none if it is waste; the green program's measures say where":
    "لا شيء إن كان هدرًا؛ وتدابير البرنامج الأخضر تحدد موضعه",
  "service levels": "مستويات الخدمة",
  "{label} cost": "تكلفة {label}",
  "Work-order overruns held to plan": "إبقاء تجاوزات أوامر العمل ضمن الخطة",
  "{n} orders over their planned cost by {amount} in the period":
    "أوامر تجاوزت تكلفتها المخططة: {n}، بمقدار {amount} خلال الفترة",
  "a planned cost that was wrong, not work that was wasteful — read the orders":
    "تكلفة مخططة كانت خاطئة، لا عمل فيه هدر — اقرأ الأوامر",
  Capital: "رأس المال",
  "Do the priced deferred work now": "تنفيذ الأعمال المؤجلة المسعّرة الآن",
  "{n} priced candidates escalate by {amount} if deferred: {list}":
    "خيارات مسعّرة: {n}، تتصاعد تكلفتها بمقدار {amount} إذا أُجّلت: {list}",
  "the cash now: {amount}": "النقد المطلوب الآن: {amount}",
  Energy: "الطاقة",
  "Unaccounted energy found and stopped": "كشف الطاقة غير المحسوبة وإيقافها",
  "{pct}% of energy unaccounted for × {amount} a year": "{pct}% من الطاقة غير محسوبة × {amount} في السنة",
  "none: it is energy nobody is using": "لا شيء: إنها طاقة لا يستخدمها أحد",
  "energy cost": "تكلفة الطاقة",
  "income a day": "الدخل اليومي",
  "{amount} over {days} days, {period}": "{amount} خلال {days} يومًا، {period}",
  revenue: "الإيرادات",
  "burn a day": "الإنفاق اليومي",
  "{amount} operating cost over {days} days": "{amount} تكلفة تشغيلية خلال {days} يومًا",
  "net a day": "الصافي اليومي",
  "{amount} against a plan of {plan}": "{amount} مقابل خطة قدرها {plan}",
  "revenue and cost": "الإيرادات والتكلفة",
  "operating margin": "هامش التشغيل",
  "plan {pct}%": "الخطة {pct}%",
  "revenue a passenger": "الإيراد لكل مسافر",
  "{n} passengers in the period": "عدد المسافرين في الفترة: {n}",
  "no passenger count entered": "لم يُدخَل عدد المسافرين",
  "revenue and passengers": "الإيرادات والمسافرون",
  "cost a passenger": "التكلفة لكل مسافر",
  "operating cost over {n} passengers": "التكلفة التشغيلية موزعة على {n} مسافر",
  "cost and passengers": "التكلفة والمسافرون",
  "capital spent": "الإنفاق الرأسمالي المصروف",
  "of {budget} budgeted on {n} projects; the platform's projects show {spent} spent of {committed} committed":
    "من {budget} مرصودة لمشاريع عددها {n}؛ وتُظهر مشاريع المنصة {spent} مصروفة من {committed} ملتزم بها",
  capital: "رأس المال",
  "on the table": "المطروح على الطاولة",
  "{n} candidates a year, cuts, recoveries and escalation avoided":
    "خيارات مرشّحة: {n} في السنة، من تخفيضات واستردادات وتصاعد مُتجنَّب",
  "{site} earns {income} a day and burns {burn}: {net} net against a plan of {plan} — on the demonstration's figures.":
    "يكسب {site} {income} في اليوم وينفق {burn}: الصافي {net} مقابل خطة قدرها {plan} — بحسب أرقام العرض التوضيحي.",
  "{site} earns {income} a day and burns {burn}: {net} net against a plan of {plan}.":
    "يكسب {site} {income} في اليوم وينفق {burn}: الصافي {net} مقابل خطة قدرها {plan}.",
  "The plan is missed on {missed} and beaten on {beaten}.": "لم تتحقق الخطة في: {missed}، وتم تجاوزها في: {beaten}.",
  "The plan is missed on {missed}.": "لم تتحقق الخطة في: {missed}.",
  nothing: "لا شيء",
  "The largest single move is {move}: {amount} a year, at the risk of {risk}.":
    "أكبر خطوة منفردة هي {move}: {amount} في السنة، مع مخاطرة {risk}.",
  "Nothing is on the table.": "لا شيء مطروح على الطاولة.",
  "revenue, operating cost and capital are the demonstration's figures until the finance system's are entered":
    "الإيرادات والتكلفة التشغيلية ورأس المال أرقام العرض التوضيحي إلى أن تُدخَل أرقام النظام المالي",
  "no passenger count, so nothing is shown per passenger": "لا يوجد عدد للمسافرين، لذا لا يُعرض شيء لكل مسافر",
  "no unaccounted-energy KPI on the platform, so energy waste is not priced":
    "لا يوجد على المنصة مؤشر KPI للطاقة غير المحسوبة، لذا لا يُسعَّر هدر الطاقة",
  "What is stopped?": "ما المتوقف؟",
  "What is late?": "ما المتأخر؟",
  "Where is spend ahead?": "أين يسبق الإنفاقُ الجدول؟",
  "The portfolio as the chief executive reads it: what is committed, what is spent against progress, what has slipped, what is stopped at a hold point — and for each project one verdict: press on, watch, rebaseline, or hold. The gates and the hold points themselves are on the":
    "المحفظة كما يقرؤها الرئيس التنفيذي: ما التُزم به، وما صُرف مقابل التقدم، وما تأخر، وما توقف عند نقطة توقف — ولكل مشروع حكم واحد: المضي قدمًا، أو المراقبة، أو إعادة خط الأساس، أو الإيقاف. أما البوابات ونقاط التوقف نفسها ففي",
  "projects screens": "شاشات المشاريع",
  "Every live project": "كل مشروع قائم",
  "worst first: stopped, then behind its baseline, then watched, then on track":
    "الأسوأ أولًا: المتوقف، ثم المتأخر عن خط أساسه، ثم الخاضع للمراقبة، ثم الذي يسير كما خُطط",
  project: "المشروع",
  verdict: "الحكم",
  budget: "الميزانية",
  spent: "المصروف",
  calendar: "المدة المنقضية",
  late: "التأخير",
  gates: "البوابات",
  "The finance system's capital lines": "بنود رأس المال في النظام المالي",
  "{name} ({pct}% done)": "{name} (منجز {pct}%)",
  "Spend ahead of progress: {list}.": "الإنفاق السابق للتقدم: {list}.",
  "What is stopped? What is late? Where is spend ahead of the calendar?":
    "ما المتوقف؟ ما المتأخر؟ أين يسبق الإنفاقُ الجدولَ الزمني؟",
  "press on": "المضي قدمًا",
  "hold — work is stopped": "إيقاف — العمل متوقف",
  rebaseline: "إعادة خط الأساس",
  watch: "مراقبة",
  complete: "مكتمل",
  delivered: "تم التسليم",
  "{n} hold point unreleased — nothing moves until they are|{n} hold points unreleased — nothing moves until they are":
    "لا نقاط توقف غير مُفرج عنها|نقطة توقف واحدة غير مُفرج عنها — لا شيء يتحرك حتى يُفرج عنها|نقطتا توقف غير مُفرج عنهما — لا شيء يتحرك حتى يُفرج عنهما|{n} نقاط توقف غير مُفرج عنها — لا شيء يتحرك حتى يُفرج عنها|{n} نقطة توقف غير مُفرج عنها — لا شيء يتحرك حتى يُفرج عنها|{n} نقطة توقف غير مُفرج عنها — لا شيء يتحرك حتى يُفرج عنها",
  "{days} days late and spend {points} points ahead of the calendar: the baseline no longer describes the job":
    "متأخر {days} يومًا والإنفاق يسبق الجدول بـ {points} نقطة: خط الأساس لم يعد يصف العمل",
  "{days} days late against the baseline: {why}": "متأخر {days} يومًا عن خط الأساس: {why}",
  "{days} days late against the baseline": "متأخر {days} يومًا عن خط الأساس",
  "spend {points} points ahead of the calendar — the money runs out before the work does":
    "الإنفاق يسبق الجدول بـ {points} نقطة — سينفد المال قبل أن ينتهي العمل",
  "{days} days late, within tolerance": "متأخر {days} يومًا، ضمن الحد المسموح",
  "spend {points} points ahead of the calendar": "الإنفاق يسبق الجدول بـ {points} نقطة",
  "no baseline to measure against — set one": "لا يوجد خط أساس للقياس عليه — حدّد واحدًا",
  "on its baseline and its budget": "ضمن خط أساسه وميزانيته",
  "{approved} of {total} gates approved": "{approved} من {total} بوابات معتمدة",
  "capital lines — demonstration figures": "بنود رأس المال — أرقام توضيحية",
  "capital lines": "بنود رأس المال",
  "live projects": "المشاريع القائمة",
  "{stopped} stopped at a hold point, {slipped} behind baseline, {unpriced} with no money declared":
    "{stopped} متوقفة عند نقطة توقف، {slipped} متأخرة عن خط الأساس، {unpriced} دون مبالغ مُعلنة",
  "budget on the platform": "الميزانية على المنصة",
  "{committed} committed, {spent} spent — {pct}% of budget":
    "{committed} ملتزم بها، {spent} مصروفة — {pct}% من الميزانية",
  "capital in the finance lines": "رأس المال في البنود المالية",
  "{spent} spent on {n} lines — {pct}%": "{spent} مصروفة على بنود عددها {n} — {pct}%",
  "no capital lines entered": "لم تُدخَل بنود رأسمالية",
  "stopped by a hold point": "متوقفة عند نقطة توقف",
  none: "لا شيء",
  "days late, worst": "أيام التأخير، الأسوأ",
  days: "أيام",
  "nothing behind its baseline": "لا شيء متأخر عن خط أساسه",
  "spend ahead of calendar, worst": "سبق الإنفاق للجدول، الأسوأ",
  "no live project": "لا يوجد مشروع قائم",
  "{n} live capital projects at {site}: {budget} budgeted on the platform, {spent} spent; the finance lines carry {finance}.":
    "المشاريع الرأسمالية القائمة في {site}: {n}؛ {budget} مرصودة على المنصة، و{spent} مصروفة؛ وتحمل البنود المالية {finance}.",
  "{n} live capital projects at {site}: {budget} budgeted on the platform, {spent} spent.":
    "المشاريع الرأسمالية القائمة في {site}: {n}؛ {budget} مرصودة على المنصة، و{spent} مصروفة.",
  "First on the desk: {name} — {verdict}: {why}.": "أولًا على المكتب: {name} — {verdict}: {why}.",
  "Every live project is on its baseline and its budget.": "كل مشروع قائم ضمن خط أساسه وميزانيته.",
  "{n} project carries no money on the platform: {names} — the portfolio total is understated by that much.":
    "مشروع واحد ({n}) لا يحمل مبالغ على المنصة: {names} — وإجمالي المحفظة أقل من حقيقته بهذا القدر.",
  "{n} projects carry no money on the platform: {names} — the portfolio total is understated by that much.":
    "مشاريع لا تحمل مبالغ على المنصة ({n}): {names} — وإجمالي المحفظة أقل من حقيقته بهذا القدر.",
  "Every live project carries its money on the platform.": "كل مشروع قائم يحمل مبالغه على المنصة.",
  "{n} projects carry no money on the platform": "مشاريع لا تحمل مبالغ على المنصة: {n}",
  "no finance capital lines": "لا توجد بنود رأسمالية مالية",
  "hold points not available": "نقاط التوقف غير متاحة",
  "{what} — demonstration figures, not the airport's": "{what} — أرقام توضيحية، وليست أرقام المطار",
  "{what} — from {file}, {period}": "{what} — من {file}، {period}",
  "demonstration figures until the finance system's are connected": "أرقام توضيحية إلى أن تُربط أرقام النظام المالي",
  "read from {file} by {who} on {date} — {period}": "قُرئت من {file} بواسطة {who} في {date} — {period}",
  "entered by {who} on {date}": "أدخلها {who} في {date}",
  "entered by {who}": "أدخلها {who}",
  "The finance figures": "الأرقام المالية",
  "the demonstration's, until the finance system's are connected or entered here — every tile that rests on them says so":
    "أرقام العرض التوضيحي، إلى أن تُربط أرقام النظام المالي أو تُدخَل هنا — وكل بطاقة تستند إليها تذكر ذلك",
  period: "الفترة",
  "finance period": "الفترة المالية",
  "days it covers": "عدد الأيام التي تغطيها",
  "days covered": "الأيام المغطاة",
  "passengers in the period": "المسافرون في الفترة",
  currency: "العملة",
  "Revenue lines — actual and plan for the period": "بنود الإيرادات — الفعلي والخطة للفترة",
  "{label} revenue actual": "إيرادات {label} الفعلية",
  "{label} revenue plan": "خطة إيرادات {label}",
  "Operating cost by area — actual and budget": "التكلفة التشغيلية حسب المجال — الفعلي والميزانية",
  "{label} cost actual": "تكلفة {label} الفعلية",
  "{label} cost budget": "ميزانية تكلفة {label}",
  "Save the finance figures": "حفظ الأرقام المالية",
  "Saved on the platform as a dated note under your name; capital lines are edited on the Capital Projects screen.":
    "تُحفظ على المنصة كملاحظة مؤرخة باسمك؛ وتُعدَّل البنود الرأسمالية من شاشة المشاريع الرأسمالية.",
  Aeronautical: "الإيرادات الملاحية",
  Retail: "التجزئة",
  Parking: "مواقف السيارات",
  Concessions: "الامتيازات",
  Advertising: "الإعلانات",
  "Operating cost": "التكلفة التشغيلية",
  Staff: "الموظفون",
  "Maintenance and contracts": "الصيانة والعقود",
  "Energy and utilities": "الطاقة والمرافق",
  "Security and services": "الأمن والخدمات",
  Other: "أخرى",
  "no header row naming an amount and an account was found in the first forty lines":
    "لم يُعثر في الأسطر الأربعين الأولى على صف عناوين يسمّي مبلغًا وحسابًا",
  "no amount could be read from the {column} column": "تعذّرت قراءة مبلغ من العمود {column}",
  "no rule matched the account name; it is counted nowhere": "لم تطابق أي قاعدة اسم الحساب؛ فهو غير محتسب في أي مكان",
  "Revenue agrees with the file's own total.": "الإيرادات مطابقة لإجمالي الملف نفسه.",
  "Revenue is {amount} away from the file's own total — some accounts did not map.":
    "تختلف الإيرادات بمقدار {amount} عن إجمالي الملف نفسه — لم تُربط بعض الحسابات.",
  "The file states no revenue total, so there is nothing to check the revenue against.":
    "لا يذكر الملف إجماليًا للإيرادات، لذا لا يوجد ما تُطابَق الإيرادات معه.",
  "Operating cost agrees with the file's own total.": "التكلفة التشغيلية مطابقة لإجمالي الملف نفسه.",
  "Operating cost is {amount} away from the file's own total.":
    "تختلف التكلفة التشغيلية بمقدار {amount} عن إجمالي الملف نفسه.",
  "The file states no operating cost total.": "لا يذكر الملف إجماليًا للتكلفة التشغيلية.",
  "{n} account(s) worth {amount} matched no rule and are counted nowhere.":
    "حسابات عددها {n} بقيمة {amount} لم تطابق أي قاعدة وغير محتسبة في أي مكان.",
  "{n} line(s) could not be read at all.": "أسطر تعذّرت قراءتها كليًا: {n}.",
  "the file's own revenue total": "إجمالي الإيرادات في الملف نفسه",
  "the file's own operating cost total": "إجمالي التكلفة التشغيلية في الملف نفسه",
  "an aeronautical charge": "رسم ملاحي",
  "retail income": "دخل التجزئة",
  "parking income": "دخل مواقف السيارات",
  "a concession or lease": "امتياز أو إيجار",
  "advertising income": "دخل الإعلانات",
  "a capital line": "بند رأسمالي",
  "a staff cost": "تكلفة موظفين",
  "maintenance or contracts": "صيانة أو عقود",
  "energy or utilities": "طاقة أو مرافق",
  "security or services": "أمن أو خدمات",
  "an other operating cost": "تكلفة تشغيلية أخرى",
  "a passenger count, not money": "عدد مسافرين، وليس مبلغًا",
  "The finance system's ledger": "دفتر الأستاذ في النظام المالي",
  "a ledger is read from a .csv or .xlsx export": "يُقرأ دفتر الأستاذ من ملف تصدير ‎.csv أو ‎.xlsx",
  "Revenue · {label}": "الإيرادات · {label}",
  "Operating cost · {label}": "التكلفة التشغيلية · {label}",
  Passengers: "المسافرون",
  "The file's own revenue total": "إجمالي الإيرادات في الملف نفسه",
  "The file's own operating cost total": "إجمالي التكلفة التشغيلية في الملف نفسه",
  "no rows could be read from that file": "تعذّرت قراءة أي صف من ذلك الملف",
  CONNECTED: "مربوط",
  "NOT CONNECTED": "غير مربوط",
  "Drop the monthly export from the finance system. Every line is placed by a rule you can read, anything that matches no rule is listed rather than dropped, and the totals are checked against the file’s own before a single figure reaches a desk.":
    "أفلت ملف التصدير الشهري من النظام المالي. يُصنَّف كل بند بقاعدة يمكنك قراءتها، وما لا يطابق أي قاعدة يُدرج ولا يُسقط، وتُطابَق الإجماليات مع إجماليات الملف نفسه قبل أن يصل أي رقم إلى أي مكتب.",
  "reading…": "جارٍ القراءة…",
  "Choose a ledger export — .csv or .xlsx": "اختر ملف تصدير دفتر الأستاذ — ‎.csv أو ‎.xlsx",
  "What the file is": "ما هو الملف",
  "{rows} row(s) read, {placed} placed, {unplaced} unplaced, {rejected} unreadable. Columns: {columns}.":
    "الصفوف المقروءة: {rows}، المصنّفة: {placed}، غير المصنّفة: {unplaced}، غير المقروءة: {rejected}. الأعمدة: {columns}.",
  "{rows} row(s) read, {placed} placed, {unplaced} unplaced. Columns: {columns}.":
    "الصفوف المقروءة: {rows}، المصنّفة: {placed}، غير المصنّفة: {unplaced}. الأعمدة: {columns}.",
  "{column} from “{header}”": "{column} من «{header}»",
  "Months {from} to {to}.": "الأشهر من {from} إلى {to}.",
  "The file states no month.": "لا يذكر الملف أي شهر.",
  "Does it add up?": "هل تتطابق الأرقام؟",
  "Revenue {revenue} · operating cost {opex}": "الإيرادات {revenue} · التكلفة التشغيلية {opex}",
  "unplaced {amount}": "غير مصنّف {amount}",
  "Placed nowhere · {n}": "غير مصنّفة في أي مكان · {n}",
  "These are in the file and in none of the figures below. They are shown rather than swept into “other”, because a total that quietly absorbs what it could not classify is the failure this screen exists to prevent.":
    "هذه موجودة في الملف وغير موجودة في أي من الأرقام أدناه. تُعرض بدل أن تُدمج في «أخرى»، لأن الإجمالي الذي يمتص بصمت ما عجز عن تصنيفه هو الخطأ الذي وُجدت هذه الشاشة لمنعه.",
  Line: "السطر",
  Account: "الحساب",
  Amount: "المبلغ",
  "Where each account went · {n}": "أين ذهب كل حساب · {n}",
  Became: "أصبح",
  Because: "السبب",
  "applied — every desk that reads money now reads {file}": "طُبّق — كل مكتب يقرأ الأرقام المالية يقرأ الآن {file}",
  "Use these figures": "استخدام هذه الأرقام",
  "Applying replaces the figures on nine desks. Each will say where they came from.":
    "يستبدل التطبيق الأرقام في تسعة مكاتب، وسيذكر كلٌّ منها مصدرها.",
  Connected: "مربوط",
  "{rows} row(s), {placed} placed": "الصفوف: {rows}، المصنّفة: {placed}",
  "{n} unplaced": "غير المصنّفة: {n}",
  "{n} unreadable": "غير المقروءة: {n}",
  "Imported by {who} on {date}.": "استوردها {who} في {date}.",
  "no such obligation on the compliance register": "لا يوجد هذا الالتزام في سجل الامتثال",
  "add the obligation to the register": "أضف الالتزام إلى السجل",
  "{title}: {status}": "{title}: {status}",
  ", due {date}": "، مستحق في {date}",
  ", met {date}": "، استُوفي في {date}",
  "run it and file the evidence — it is overdue": "نفّذه وأودِع الأدلة — إنه متأخر",
  "schedule it before it falls due": "جدوِله قبل موعد استحقاقه",
  "in the library: {titles}": "في المكتبة: {titles}",
  "expired: {titles}": "منتهية الصلاحية: {titles}",
  // prettier-ignore
  "no issued document matching \"{match}\" in the library": "لا توجد في المكتبة وثيقة صادرة تطابق \"{match}\"",
  "issue the document in the library, tagged so the desk can find it":
    "أصدِر الوثيقة في المكتبة بوسم يتيح للمكتب العثور عليها",
  "no KPI {key} on the platform": "لا يوجد مؤشر الأداء {key} على المنصة",
  "connect the feed": "اربط مصدر البيانات",
  "{label}: {value} {unit} against a target of {target}": "{label}: {value} {unit} مقابل مستهدف قدره {target}",
  "not computable": "غير قابل للحساب",
  "make the KPI computable": "اجعل مؤشر الأداء قابلًا للحساب",
  "bring the KPI within target": "أعِد مؤشر الأداء إلى حدود المستهدف",
  "open: {titles}": "مفتوح: {titles}",
  "no severity-5 alert open": "لا يوجد تنبيه مفتوح بدرجة خطورة 5",
  "close the alert — the work is mandatory": "أغلِق التنبيه — العمل إلزامي",
  "covered; {positions}: {list}": "مغطّى؛ {positions}: {list}",
  "not covered: {why}": "غير مغطّى: {why}",
  "no capacity model": "لا يوجد نموذج للسعة",
  "the next 90 days": "الأيام الـ 90 القادمة",
  "load the schedule so the model can price a closure": "حمّل جدول الرحلات ليتمكن النموذج من تسعير الإغلاق",
  "not assessed": "لم يُقيَّم",
  "movements in the window": "الحركات خلال الفترة",
  "{movements} in {hours} h: {stranded} stranded, {bussed} bussed":
    "{movements} خلال {hours} h: {stranded} عالقة، {bussed} بالحافلات",
  "unknown — the capacity model has no schedule": "غير معروف — لا يوجد جدول رحلات في نموذج السعة",
  "closure cost": "تكلفة الإغلاق",
  "cost of {hours} h closed": "تكلفة إغلاق لمدة {hours} h",
  "closure cost per hour, runway": "تكلفة الإغلاق في الساعة، المدرج",
  "{minutes} min — the longest unplanned closure on record": "{minutes} min — أطول إغلاق غير مخطط له في السجلات",
  "equipment already out": "المعدات المتوقفة أصلًا",
  "{value} {unit} before the event ({source})": "{value} {unit} قبل الحدث ({source})",
  "no equipment KPI": "لا يوجد مؤشر أداء للمعدات",
  "terminal cost per hour": "تكلفة مبنى الركاب في الساعة",
  "{cost} on the rate card": "{cost} وفق جدول الأسعار",
  "closure cost per hour, terminal": "تكلفة الإغلاق في الساعة، مبنى الركاب",
  "worst queue today": "أسوأ طابور اليوم",
  "{value} {unit} against {target}": "{value} {unit} مقابل {target}",
  "no queue KPI": "لا يوجد مؤشر أداء للطوابير",
  "positions that strand traffic": "المواقع التي تُعلِّق الحركة",
  "priced on the capacity model where it covers the window, else the rate card, and it says which":
    "مسعّر وفق نموذج السعة حيث يغطي الفترة، وإلا فوفق جدول الأسعار، مع بيان أيهما",
  "the platform holds nothing to price this scenario with": "لا تملك المنصة ما يُسعَّر به هذا السيناريو",
  "emergency exercise": "تمرين الطوارئ",
  "not on the register": "غير مدرج في السجل",
  "severity-5 alerts open": "تنبيهات مفتوحة بدرجة خطورة 5",
  "major equipment out": "معدات رئيسية متوقفة",
  "target {target}; {source}": "المستهدف {target}؛ {source}",
  "no KPI": "لا يوجد مؤشر أداء",
  "security incidents open": "حوادث أمنية مفتوحة",
  "target {target}": "المستهدف {target}",
  "readiness gaps": "فجوات الجاهزية",
  "across {n} playbooks; least ready: {name} at {score}%":
    "عبر {n} من خطط الاستجابة؛ الأقل جاهزية: {name} بنسبة {score}%",
  "last drill recorded": "آخر تمرين مسجّل",
  "none recorded here": "لم يُسجَّل شيء هنا",
  "drill log": "سجل التمارين",
  "Crisis readiness at {site}: {gaps} across {n} playbooks; the emergency exercise is {status}.":
    "الجاهزية للأزمات في {site}: {gaps} عبر {n} من خطط الاستجابة؛ حالة تمرين الطوارئ: {status}.",
  "The drill to run first is {name}: {met} of {total} needs met, {missing}.":
    "التمرين الذي يُجرى أولًا هو {name}: استُوفي {met} من {total} من المتطلبات، {missing}.",
  "nothing missing": "لا نقص",
  "No playbooks.": "لا توجد خطط استجابة.",
  "No severity-5 alert is open; the desk is about readiness, not response.":
    "لا يوجد تنبيه مفتوح بدرجة خطورة 5؛ هذا المكتب معنيّ بالجاهزية لا بالاستجابة.",
  "the compliance register is not on the platform": "سجل الامتثال غير موجود على المنصة",
  "the capacity model does not cover the next 90 days": "نموذج السعة لا يغطي الأيام الـ 90 القادمة",
  "{n} critical position|{n} critical positions":
    "لا مواقع حرجة|موقع حرج واحد|موقعان حرجان|{n} مواقع حرجة|{n} موقعًا حرجًا|{n} موقع حرج",
  "{n} gap|{n} gaps": "لا فجوات|فجوة واحدة|فجوتان|{n} فجوات|{n} فجوة|{n} فجوة",
  "{n} severity-5 alert is open now — the first scenario is already half underway.|{n} severity-5 alerts are open now — the first scenario is already half underway.":
    "لا يوجد تنبيه مفتوح بدرجة خطورة 5 الآن.|تنبيه واحد بدرجة خطورة 5 مفتوح الآن — السيناريو الأول قد بدأ فعلًا.|تنبيهان بدرجة خطورة 5 مفتوحان الآن — السيناريو الأول قد بدأ فعلًا.|{n} تنبيهات بدرجة خطورة 5 مفتوحة الآن — السيناريو الأول قد بدأ فعلًا.|{n} تنبيهًا بدرجة خطورة 5 مفتوحًا الآن — السيناريو الأول قد بدأ فعلًا.|{n} تنبيه بدرجة خطورة 5 مفتوح الآن — السيناريو الأول قد بدأ فعلًا.",
  "Is the airport ready for the day something breaks, and what happens in the first quarter of an hour when it does. Readiness is read from the records — the emergency exercise, the open alerts, the equipment out of service, the capacity model, the library — and every gap names the record that would close it.":
    "هل المطار جاهز لليوم الذي يتعطل فيه شيء، وماذا يحدث في الربع الأول من الساعة حين يقع ذلك. تُقرأ الجاهزية من السجلات — تمرين الطوارئ، والتنبيهات المفتوحة، والمعدات المتوقفة عن الخدمة، ونموذج السعة، والمكتبة — وكل فجوة تسمّي السجل الذي يسدّها.",
  Playbooks: "خطط الاستجابة",
  "{score}% ready": "جاهز بنسبة {score}%",
  "drill first": "يُجرى أولًا",
  "{met} of {total} needs met: missing {missing}": "استُوفي {met} من {total} من المتطلبات: ينقص {missing}",
  "{met} of {total} needs met": "استُوفي {met} من {total} من المتطلبات",
  "Which drill first? What is missing for a runway closure? What does a power loss cost?":
    "أي تمرين أولًا؟ ما الذي ينقص لإغلاق المدرج؟ كم تكلّف خسارة الكهرباء؟",
  "{met} of {total} needs met · {note}": "استُوفي {met} من {total} من المتطلبات · {note}",
  "Who holds the first quarter of an hour": "من يتولى الربع الأول من الساعة",
  "The first quarter of an hour": "الربع الأول من الساعة",
  "The drill, priced": "التمرين مسعّرًا",
  "rate card": "جدول الأسعار",
  "nothing on the platform prices this scenario": "لا شيء على المنصة يسعّر هذا السيناريو",
  "What the platform must show, and does": "ما يجب أن تُظهره المنصة، وما تُظهره",
  met: "مستوفى",
  gap: "فجوة",
  "To close it: {todo}": "لسدّها: {todo}",
  "{currency} figures on the rate card are starting values until the airport edits them.":
    "أرقام {currency} في جدول الأسعار قيم مبدئية إلى أن يعدّلها المطار.",
  "drill playbook": "خطة الاستجابة للتمرين",
  "drill date": "تاريخ التمرين",
  "the one thing to fix before the real one": "الأمر الوحيد الذي يجب إصلاحه قبل الحدث الحقيقي",
  "drill lesson": "الدرس المستفاد من التمرين",
  "Record the drill": "تسجيل التمرين",
  "What the platform could not supply": "ما لم تستطع المنصة توفيره",
  "absent inputs, so the reader knows what this desk does not cover":
    "مدخلات غائبة، ليعرف القارئ ما لا يغطيه هذا المكتب",
  "Exercises and drills": "التمارين والمناورات",
  "recorded here, attributed and dated, so the desk knows what was rehearsed and what was learned":
    "تُسجَّل هنا منسوبةً ومؤرّخة، ليعرف المكتب ما جرى التدرّب عليه وما استُفيد منه",
  playbook: "خطة الاستجابة",
  date: "التاريخ",
  "what was learned": "ما استُفيد",
  "Which drill first?": "أي تمرين أولًا؟",
  "What is missing?": "ما الذي ينقص؟",
  "The board line": "سطر مجلس الإدارة",
  overdue: "متأخر",
  pending: "قيد الانتظار",
  waived: "مُعفى",
  "Runway closed without notice": "إغلاق المدرج دون إشعار مسبق",
  "a disabled aircraft, a pavement failure, a FOD find that cannot be cleared, a friction reading below the limit in rain":
    "طائرة معطّلة، أو انهيار في الرصف، أو أجسام غريبة (FOD) يتعذّر إزالتها، أو قراءة احتكاك دون الحد في المطر",
  "Duty operations manager": "مدير العمليات المناوب",
  "Airside operations": "عمليات الجانب الجوي",
  "ATC liaison": "منسّق المراقبة الجوية",
  "Airline liaison": "منسّق شركات الطيران",
  "Declare the closure to ATC and issue the NOTAM; log the time.":
    "أعلِن الإغلاق للمراقبة الجوية وأصدِر إشعار الطيارين (NOTAM)؛ سجّل الوقت.",
  "Open the capacity model for the runway and read the movements in the next four hours.":
    "افتح نموذج السعة للمدرج واقرأ الحركات في الساعات الأربع القادمة.",
  "Stand up airline liaison: diversions, holds and the bussing plan for stranded movements.":
    "فعّل التنسيق مع شركات الطيران: التحويلات والانتظار وخطة النقل بالحافلات للحركات العالقة.",
  "Dispatch the airside inspection and the pavements crew; open a work order from the alert.":
    "أرسِل فريق فحص الجانب الجوي وطاقم الرصف؛ وافتح أمر عمل من التنبيه.",
  "Brief the chief executive with the movements affected and the earliest reopening.":
    "أطلِع الرئيس التنفيذي على الحركات المتأثرة وأقرب موعد لإعادة الفتح.",
  "the aerodrome emergency exercise is current": "تمرين الطوارئ في المطار ساري",
  "no runway alert at severity 5 is open": "لا يوجد تنبيه مفتوح للمدرج بدرجة خطورة 5",
  "the capacity model covers the next 90 days": "نموذج السعة يغطي الأيام الـ 90 القادمة",
  "the aerodrome emergency plan is issued in the library": "خطة الطوارئ للمطار صادرة في المكتبة",
  "Total loss of power": "انقطاع كامل للكهرباء",
  "a grid failure with the standby set failing to take the load":
    "انقطاع الشبكة مع إخفاق المولد الاحتياطي في تحمّل الحمل",
  "Duty engineer": "المهندس المناوب",
  "Electrical crew": "طاقم الكهرباء",
  "Terminal operations": "عمليات مبنى الركاب",
  Security: "الأمن",
  "Confirm the standby set and the UPS on the AGL and the tower; start the second set.":
    "تأكّد من المولد الاحتياطي ومزوّد الطاقة غير المنقطعة (UPS) للإنارة الأرضية للمطار (AGL) وبرج المراقبة؛ وشغّل المولد الثاني.",
  "Hold departures until the AGL circuits are confirmed on standby power.":
    "أوقف المغادرات حتى يُتأكَّد من عمل دوائر AGL على الطاقة الاحتياطية.",
  "Terminal: lifts, screening lanes and the baggage lines to manual procedure.":
    "مبنى الركاب: المصاعد وممرات التفتيش وخطوط الأمتعة إلى الإجراء اليدوي.",
  "Open the electrical serviceability round and log every circuit as it returns.":
    "ابدأ جولة فحص صلاحية الكهرباء وسجّل كل دائرة عند عودتها.",
  "the weekly AGL night serviceability check is current": "الفحص الليلي الأسبوعي لصلاحية AGL ساري",
  "major equipment out of service is within target": "المعدات الرئيسية المتوقفة عن الخدمة ضمن المستهدف",
  "Security breach or threat": "اختراق أمني أو تهديد",
  "a perimeter breach, an unattended item, a credible threat to the terminal":
    "اختراق للسياج المحيطي، أو غرض متروك دون مراقبة، أو تهديد جدّي لمبنى الركاب",
  "Duty security manager": "مدير الأمن المناوب",
  "Police liaison": "منسّق الشرطة",
  Communications: "الاتصال المؤسسي",
  "Isolate the area and hold the screening lanes; log the time.": "اعزل المنطقة وأوقف ممرات التفتيش؛ سجّل الوقت.",
  "Police and the security programme's chain of command informed.": "إبلاغ الشرطة وسلسلة القيادة في البرنامج الأمني.",
  "Passenger flow re-routed; the queue KPI watched live.":
    "إعادة توجيه تدفق الركاب؛ ومراقبة مؤشر أداء الطوابير مباشرة.",
  "One spokesperson, one statement, cleared by the chief executive.": "متحدث واحد وبيان واحد يعتمده الرئيس التنفيذي.",
  "no security incident is open": "لا توجد حادثة أمنية مفتوحة",
  "the security programme is issued in the library": "البرنامج الأمني صادر في المكتبة",
  "Sandstorm or severe wind": "عاصفة رملية أو رياح شديدة",
  "visibility below minima, wind above the aircraft limits, sand on the movement area":
    "رؤية دون الحد الأدنى، أو رياح تتجاوز حدود الطائرات، أو رمال على منطقة الحركة",
  "Met liaison": "منسّق الأرصاد الجوية",
  "Read the weather disruption KPI and the forecast window; brief the airlines.":
    "اقرأ مؤشر أداء اضطرابات الطقس ونافذة التوقعات؛ وأطلِع شركات الطيران.",
  "Sweepers staged; the FOD and friction rounds brought forward for the recovery.":
    "تجهيز الكاسحات؛ وتقديم جولات FOD والاحتكاك استعدادًا للتعافي.",
  "Ground handling equipment secured; stands checked for loose items.":
    "تثبيت معدات الخدمات الأرضية؛ وفحص مواقف الطائرات بحثًا عن أغراض سائبة.",
  "Passengers informed once, with a time to expect the next update.": "إبلاغ الركاب مرة واحدة مع موعد التحديث التالي.",
  "weather disruption today is within target": "اضطرابات الطقس اليوم ضمن المستهدف",
  "Baggage system failure": "عطل نظام الأمتعة",
  "a line down at peak, a sortation fault, a screening integration failure":
    "توقف خط في ساعة الذروة، أو عطل في الفرز، أو إخفاق في تكامل التفتيش",
  "Baggage engineering": "هندسة الأمتعة",
  "Handling agents": "وكلاء الخدمات الأرضية",
  "Manual sortation opened; handlers redeployed to it.": "تشغيل الفرز اليدوي؛ وإعادة توزيع العاملين عليه.",
  "Departures held only where bags cannot be reconciled.": "إيقاف المغادرات فقط حيث تتعذّر مطابقة الأمتعة.",
  "Engineering on the fault with the work order raised from the alert.":
    "الهندسة تعالج العطل بأمر عمل صادر من التنبيه.",
  "Bags-on-time KPI watched; the airlines told which flights will go without bags.":
    "مراقبة مؤشر أداء تسليم الأمتعة في الوقت؛ وإبلاغ شركات الطيران بالرحلات التي ستغادر دون أمتعة.",
  "bags delivered on time is within target": "تسليم الأمتعة في الوقت ضمن المستهدف",
  "Aircraft accident or mass casualty": "حادث طائرة أو إصابات جماعية",
  "an aircraft accident on or near the aerodrome": "حادث طائرة في المطار أو بالقرب منه",
  "Chief executive": "الرئيس التنفيذي",
  "Rescue and fire fighting": "الإنقاذ ومكافحة الحريق",
  Medical: "الخدمات الطبية",
  "Police and civil defence liaison": "منسّق الشرطة والدفاع المدني",
  "Rescue and fire fighting responding; the emergency plan's alerting cascade started.":
    "فرق الإنقاذ ومكافحة الحريق تستجيب؛ وبدء تسلسل الإنذار في خطة الطوارئ.",
  "Runway and the movement area closed; ATC informed.": "إغلاق المدرج ومنطقة الحركة؛ وإبلاغ المراقبة الجوية.",
  "Emergency operations centre opened; the chief executive in it.": "افتتاح مركز عمليات الطوارئ؛ والرئيس التنفيذي فيه.",
  "Family assistance and the media line stood up on the plan's wording.":
    "تفعيل مساعدة الأسر والخط الإعلامي وفق صياغة الخطة.",
  "the wildlife hazard assessment is current": "تقييم خطر الحياة الفطرية ساري",
  "{what} — to {to}": "{what} — إلى {to}",
  "Inspection by {inspector}": "فحص من قِبل {inspector}",
  "inspection date": "تاريخ الفحص",
  "{met} of {total} met, {overdue} overdue, {pending} pending":
    "استُوفي {met} من {total}، متأخر {overdue}، قيد الانتظار {pending}",
  readiness: "الجاهزية",
  "limits crossed": "الحدود المتجاوزة",
  "certificates expired": "الشهادات منتهية الصلاحية",
  "none; {n} expiring inside 180 days": "لا يوجد؛ عدد ما ينتهي خلال 180 يومًا: {n}",
  "cost to close the findings": "تكلفة معالجة الملاحظات",
  "{crossed} and {overdue} on the rate card": "{crossed} و{overdue} وفق جدول الأسعار",
  "repair and evidence costs by category": "تكاليف الإصلاح والأدلة حسب الفئة",
  "rules not verified": "قواعد غير متحقَّق منها",
  "every rule that needs verification has it": "كل قاعدة تحتاج إلى تحقّق قد تحقّق منها",
  "days to the inspection": "أيام حتى الفحص",
  "no inspection date entered": "لم يُدخَل تاريخ الفحص",
  "undertakings open": "التعهدات المفتوحة",
  "{what} by {due}": "{what} بحلول {due}",
  "none recorded": "لم يُسجَّل شيء",
  "{unverified} rules are unverified and {proposed} KPI targets proposed — a finding the inspector can make without leaving the desk.":
    "عدد القواعد غير المتحقَّق منها: {unverified}، وعدد مستهدفات مؤشرات الأداء المقترحة: {proposed} — ملاحظة يستطيع المفتش تسجيلها دون مغادرة مكتبه.",
  "{proposed} KPI targets are still proposed rather than agreed.":
    "عدد مستهدفات مؤشرات الأداء التي ما زالت مقترحة لا متفقًا عليها: {proposed}.",
  "every rule is verified and every target agreed.": "كل قاعدة متحقَّق منها وكل مستهدف متفق عليه.",
  "{site} meets {met} of {total} obligations across {frameworks} frameworks; {overdue} overdue, {limits} crossed, {certificates} expired.":
    "يستوفي {site} عدد {met} من {total} من الالتزامات عبر {frameworks} من الأطر؛ المتأخر: {overdue}، والمتجاوز: {limits}، ومنتهي الصلاحية: {certificates}.",
  "Next up: {items}.": "القادم: {items}.",
  "{title} ({state}, {when})": "{title} ({state}، {when})",
  "{n} days ago": "قبل {n} يومًا",
  "in {n} days": "بعد {n} يومًا",
  "Nothing falls due in the next ninety days.": "لا شيء يستحق خلال التسعين يومًا القادمة.",
  "Closing every finding costs about {cost} on the rate card, with {days} days to the inspection; {rest}":
    "تبلغ تكلفة معالجة كل الملاحظات نحو {cost} وفق جدول الأسعار، مع بقاء {days} يومًا حتى الفحص؛ {rest}",
  "Closing every finding costs about {cost} on the rate card; {rest}":
    "تبلغ تكلفة معالجة كل الملاحظات نحو {cost} وفق جدول الأسعار؛ {rest}",
  "{n} tests are overdue": "عدد الاختبارات المتأخرة: {n}",
  "no testing summary": "لا يوجد ملخّص للاختبارات",
  "{n} crossed limit|{n} crossed limits":
    "لا حدود متجاوزة|حد متجاوز واحد|حدّان متجاوزان|{n} حدود متجاوزة|{n} حدًّا متجاوزًا|{n} حد متجاوز",
  "{n} overdue obligation|{n} overdue obligations":
    "لا التزامات متأخرة|التزام متأخر واحد|التزامان متأخران|{n} التزامات متأخرة|{n} التزامًا متأخرًا|{n} التزام متأخر",
  "{n} limit|{n} limits": "لا حدود|حد واحد|حدّان|{n} حدود|{n} حدًّا|{n} حد",
  "{n} certificate|{n} certificates": "لا شهادات|شهادة واحدة|شهادتان|{n} شهادات|{n} شهادة|{n} شهادة",
  due: "مستحق",
  expiring: "تنتهي قريبًا",
  expired: "منتهية الصلاحية",
  missed: "فائت",
  scheduled: "مجدول",
  obligation: "التزام",
  certificate: "شهادة",
  undertaking: "تعهد",
  inspection: "فحص",
  "What the regulator can ask for, when, and what it costs to be ready: readiness by framework, the ninety-day calendar of obligations and certificates, the limits crossed and the rules that carry them, the undertakings the airport has given, and the targets still proposed rather than agreed. The decision — close every gap, disclose with a plan, or fix the crossed limits only — is framed in the {link}.":
    "ما يمكن أن تطلبه الجهة التنظيمية، ومتى، وكم تكلّف الجاهزية له: الجاهزية حسب الإطار، وتقويم التسعين يومًا للالتزامات والشهادات، والحدود المتجاوزة والقواعد التي تحملها، والتعهدات التي قدّمها المطار، والمستهدفات التي ما زالت مقترحة لا متفقًا عليها. يُصاغ القرار — سدّ كل فجوة، أو الإفصاح مع خطة، أو معالجة الحدود المتجاوزة فقط — في {link}.",
  "{n} d ago": "قبل {n} يوم",
  "in {n} d": "بعد {n} يوم",
  "{n} — each a finding the inspector can make from the platform's own readings":
    "{n} — كلٌّ منها ملاحظة يستطيع المفتش تسجيلها من قراءات المنصة نفسها",
  "No limit is crossed.": "لا يوجد حد متجاوز.",
  "{reference}; about {cost} to close on the rate card": "{reference}؛ نحو {cost} للمعالجة وفق جدول الأسعار",
  "no clause reference on the rule; about {cost} to close on the rate card":
    "لا يوجد مرجع بند على القاعدة؛ نحو {cost} للمعالجة وفق جدول الأسعار",
  "Rule {rule} needs verification and has none ({reference}).":
    "القاعدة {rule} تحتاج إلى تحقّق ولم يُتحقَّق منها ({reference}).",
  "Rule {rule} needs verification and has none.": "القاعدة {rule} تحتاج إلى تحقّق ولم يُتحقَّق منها.",
  "KPI target for {kpi} is proposed, not agreed.": "مستهدف مؤشر الأداء {kpi} مقترح وغير متفق عليه.",
  "Every rule that needs verification has it and every target is agreed or from the pack.":
    "كل قاعدة تحتاج إلى تحقّق قد تحقّق منها، وكل مستهدف متفق عليه أو من الحزمة المعتمدة.",
  "What falls due next? What does it cost to close every finding? Which rules are unverified?":
    "ما الذي يستحق تاليًا؟ كم تكلّف معالجة كل الملاحظات؟ ما القواعد غير المتحقَّق منها؟",
  "The inspection and the undertakings — entered here because the platform does not hold them":
    "الفحص والتعهدات — تُدخَل هنا لأن المنصة لا تحتفظ بها",
  inspector: "المفتش",
  "Save the inspection": "حفظ الفحص",
  "Record an undertaking": "تسجيل تعهد",
  "undertaking to": "التعهد إلى",
  "undertaking due": "موعد التعهد",
  "undertaking owner": "المسؤول عن التعهد",
  "Record it": "تسجيله",
  "{what} to {to}, by {due}, {owner}": "{what} إلى {to}، بحلول {due}، {owner}",
  "status of {what}": "حالة {what}",
  "The next ninety days": "التسعون يومًا القادمة",
  "overdue and expired first, then what falls due — obligations, certificates, undertakings, the inspection":
    "المتأخر والمنتهي أولًا، ثم ما يستحق — الالتزامات والشهادات والتعهدات والفحص",
  "Limits crossed": "الحدود المتجاوزة",
  "Rules unverified and targets proposed": "قواعد غير متحقَّق منها ومستهدفات مقترحة",
  "findings an inspector can make without leaving the desk": "ملاحظات يستطيع المفتش تسجيلها دون مغادرة مكتبه",
  "The inspection and the undertakings": "الفحص والتعهدات",
  "an undertaking is a promise with a date; a missed one is a finding in its own right":
    "التعهد وعدٌ بتاريخ؛ والتعهد الفائت ملاحظة بحد ذاته",
  to: "إلى",
  "what was promised": "ما وُعِد به",
  by: "بحلول",
  owner: "المسؤول",
  "What falls due next?": "ما الذي يستحق تاليًا؟",
  "Which limits are crossed?": "ما الحدود المتجاوزة؟",
  "Cost to close": "تكلفة المعالجة",
  "When do we run out of room?": "متى تنفد السعة لدينا؟",
  "Which option first?": "أي خيار نبدأ به؟",
  "Apron expansion": "توسعة ساحة وقوف الطائرات",
  "more stands on the apron; relieves the stand constraint, not the terminal":
    "مواقف أكثر على ساحة وقوف الطائرات؛ يخفف قيد المواقف لا قيد مبنى الركاب",
  "Already in the capital program; stands are the constraint the capacity model can see.":
    "مدرج أصلًا في برنامج الإنفاق الرأسمالي؛ والمواقف هي القيد الذي يراه نموذج السعة.",
  "Does nothing for the terminal, which saturates on its own curve.":
    "لا يفيد مبنى الركاب في شيء، إذ يبلغ تشبّعه وفق منحناه الخاص.",
  "Remote stands with bussing": "مواقف بعيدة مع النقل بالحافلات",
  "paved remote positions and a bussing operation; quick, but every passenger on them is bussed":
    "مواقف بعيدة مرصوفة وتشغيل للحافلات؛ سريع التنفيذ، لكن كل راكب عليها يُنقل بالحافلة",
  "A year, not three; reversible if the apron follows.": "سنة واحدة لا ثلاث؛ ويمكن التراجع عنه إذا تلته توسعة الساحة.",
  "Bussing is a passenger cost and a queue-KPI cost every day it runs.":
    "النقل بالحافلات كلفة على الراكب وعلى مؤشر الطوابير في كل يوم يعمل فيه.",
  "Terminal pier extension": "تمديد رصيف مبنى الركاب",
  "a pier with contact stands and gate rooms; relieves the terminal and the stands together":
    "رصيف بمواقف ملاصقة وصالات بوابات؛ يخفف قيد مبنى الركاب وقيد المواقف معًا",
  "The only option that moves the terminal constraint.": "الخيار الوحيد الذي يزحزح قيد مبنى الركاب.",
  "The largest cash call and the longest build; must start before the terminal saturates, not when.":
    "أكبر طلب للنقد وأطول مدة بناء؛ يجب أن يبدأ قبل تشبّع مبنى الركاب لا عنده.",
  "Spread the peak with the airlines": "توزيع الذروة بالتنسيق مع شركات الطيران",
  "schedule coordination that moves movements out of the peak hour; adds effective capacity without concrete":
    "تنسيق للجداول ينقل الحركات خارج ساعة الذروة؛ يضيف سعة فعلية دون خرسانة",
  "Cheapest room there is; the capacity model shows which positions have slack.":
    "أرخص سعة ممكنة؛ ونموذج السعة يبيّن المواقف التي فيها فائض.",
  "Depends on airlines agreeing to slots they did not ask for.": "يعتمد على قبول شركات الطيران مواعيد لم تطلبها.",
  "Faster processing in the terminal": "معالجة أسرع في مبنى الركاب",
  "self-service bag drop, e-gates and more screening lanes; raises what the building handles without extending it":
    "تسليم ذاتي للأمتعة وبوابات إلكترونية ومسارات تفتيش أكثر؛ يرفع ما يستوعبه المبنى دون توسيعه",
  "Moves the terminal constraint at a tenth of a pier's cost.": "يزحزح قيد مبنى الركاب بعُشر كلفة الرصيف.",
  "A ceiling, not a floor: the building's curb, hold rooms and gates still bind.":
    "سقف لا أرضية: رصيف الوصول وصالات الانتظار والبوابات تبقى قيودًا.",
  "{constraint} binds first: {pct}% used today, saturating in {year} at {growth}% growth ({high} at a third less, {low} at a third more).":
    "{constraint} هو القيد الأول: {pct}% مستخدم اليوم، ويبلغ التشبّع في {year} بنمو {growth}% ({high} بنمو أقل بالثلث، و{low} بنمو أكثر بالثلث).",
  "{constraint} binds first: {pct}% used today, saturating never at this growth at {growth}% growth ({high} at a third less, {low} at a third more).":
    "{constraint} هو القيد الأول: {pct}% مستخدم اليوم، ولا يبلغ التشبّع أبدًا بنمو {growth}% ({high} بنمو أقل بالثلث، و{low} بنمو أكثر بالثلث).",
  "No constraint entered.": "لم يُدخَل أي قيد.",
  "{name}: {cost} for {adds} — {perPax}, {months} months, start by {startBy}.":
    "{name}: {cost} مقابل {adds} — {perPax}، المدة {months} شهر، البدء بحلول {startBy}.",
  "{n} passengers a year": "{n} راكب سنويًا",
  "{n} stands": "مواقف عددها {n}",
  "{amount} a passenger": "{amount} للراكب",
  "not priced per passenger": "غير مسعّر للراكب",
  "{name} would need to have started in {year}: the room arrives after the constraint binds, so the two-way options buy the time.":
    "كان يلزم أن يبدأ {name} في {year}: السعة تصل بعد أن يصبح القيد نافذًا، لذا تشتري الخيارات القابلة للتراجع الوقت اللازم.",
  "growing {growth}% a year; {pct}% of plan this period": "نمو {growth}% سنويًا؛ {pct}% من الخطة في هذه الفترة",
  "growing {growth}% a year": "نمو {growth}% سنويًا",
  "{constraint} used": "المستخدم من {constraint}",
  "{demand} of {capacity} {unit}; saturates in {year}": "{demand} من {capacity} {unit}؛ يبلغ التشبّع في {year}",
  "{demand} of {capacity} {unit}; saturates never at this growth":
    "{demand} من {capacity} {unit}؛ لا يبلغ التشبّع أبدًا بهذا النمو",
  "{critical}; flexible: {flexible}": "{critical}؛ المرنة: {flexible}",
  "unknown: {reason}": "غير معروف: {reason}",
  "worst queue": "أسوأ طابور",
  "target {target} — the terminal constraint as passengers feel it":
    "المستهدف {target} — قيد مبنى الركاب كما يشعر به الركاب",
  "{site} runs out of {constraint} first: {pct}% used, saturating in {year} at {growth}% growth.":
    "أول ما تنفد سعته في {site} هو {constraint}: {pct}% مستخدم، ويبلغ التشبّع في {year} بنمو {growth}%.",
  "{site} runs out of {constraint} first: {pct}% used, saturating never at this growth at {growth}% growth.":
    "أول ما تنفد سعته في {site} هو {constraint}: {pct}% مستخدم، ولا يبلغ التشبّع أبدًا بنمو {growth}%.",
  "{name} relieves it at {cost}, {perPax} a passenger, and must start by {startBy}.":
    "يخففه {name} بكلفة {cost}، أي {perPax} للراكب، ويجب أن يبدأ بحلول {startBy}.",
  "{name} relieves it at {cost}, unpriced per passenger, and must start by {startBy}.":
    "يخففه {name} بكلفة {cost}، دون تسعير للراكب، ويجب أن يبدأ بحلول {startBy}.",
  "No option relieves the binding constraint.": "لا يوجد خيار يخفف القيد النافذ.",
  "That start date has passed: the two-way options — spreading the peak, remote stands, faster processing — buy the time the build needs.":
    "فات موعد البدء هذا: الخيارات القابلة للتراجع — توزيع الذروة والمواقف البعيدة والمعالجة الأسرع — تشتري الوقت الذي يحتاجه البناء.",
  "The figures are starting values until the airport's own are entered.":
    "الأرقام قيم ابتدائية حتى تُدخَل أرقام المطار نفسه.",
  "The figures are the airport's own.": "الأرقام هي أرقام المطار نفسه.",
  "demand and capacity figures are starting values until entered": "أرقام الطلب والسعة قيم ابتدائية حتى تُدخَل",
  "When the airport runs out of room, on which constraint first, and what each way of adding room costs per passenger it admits. Demand and design capacity are entered; the positions that strand traffic come from the capacity model; saturation is arithmetic on those at the entered growth, and at a third less and a third more.":
    "متى تنفد سعة المطار، وعلى أي قيد أولًا، وكم تكلف كل طريقة لإضافة السعة عن كل راكب تستوعبه. الطلب والسعة التصميمية مُدخَلان؛ والمواقف التي تعطّل الحركة تأتي من نموذج السعة؛ والتشبّع حساب على هذه الأرقام بالنمو المُدخَل، وبنمو أقل بالثلث وأكثر بالثلث.",
  "{constraint} binds first": "{constraint} هو القيد الأول",
  "no constraint entered": "لم يُدخَل أي قيد",
  "The constraints": "القيود",
  constraint: "القيد",
  demand: "الطلب",
  capacity: "السعة",
  used: "المستخدم",
  saturates: "يبلغ التشبّع",
  "at a third more growth": "بنمو أكثر بالثلث",
  "at a third less": "بنمو أقل بالثلث",
  Terminal: "مبنى الركاب",
  Stands: "مواقف الطائرات",
  Runway: "المدرج",
  terminal: "مبنى الركاب",
  stands: "مواقف الطائرات",
  runway: "المدرج",
  "pax/yr": "راكب/سنة",
  "movements/h": "حركة/ساعة",
  "starting values": "قيم ابتدائية",
  never: "أبدًا",
  Options: "الخيارات",
  recommended: "موصى به",
  "one-way door": "قرار غير قابل للتراجع",
  "two-way door": "قرار قابل للتراجع",
  "starting figures": "أرقام ابتدائية",
  "{n} months": "{n} شهر",
  "{amount}/pax": "{amount}/راكب",
  "unpriced per pax": "غير مسعّر للراكب",
  relieves: "يخفف",
  adds: "يضيف",
  "start by": "البدء بحلول",
  "no saturation date to work back from": "لا يوجد تاريخ تشبّع يُحسب منه",
  "For.": "مع.",
  "Against.": "ضد.",
  "The reasoning": "المنطق",
  "cost per passenger admitted, for the options that relieve the binding constraint":
    "الكلفة عن كل راكب مُستوعَب، للخيارات التي تخفف القيد النافذ",
  "When do we run out of stands? Which option first? What does the pier cost per passenger?":
    "متى تنفد المواقف؟ أي خيار أولًا؟ كم يكلف الرصيف للراكب؟",
  "Demand and capacity — the figures every year above rests on": "الطلب والسعة — الأرقام التي تقوم عليها كل سنة أعلاه",
  "Demand and capacity": "الطلب والسعة",
  "blank fields run on starting values and every figure that depends on them is marked":
    "الحقول الفارغة تعمل بالقيم الابتدائية، وكل رقم يعتمد عليها مُعلَّم",
  "{label} (starting {value})": "{label} (القيمة الابتدائية {value})",
  "growth % a year": "النمو % سنويًا",
  "terminal design capacity, pax/yr": "السعة التصميمية لمبنى الركاب، راكب/سنة",
  "contact stands": "المواقف الملاصقة",
  "remote stands": "المواقف البعيدة",
  "stands needed at terminal capacity": "المواقف اللازمة عند بلوغ سعة مبنى الركاب",
  "declared runway capacity, movements/h": "السعة المعلنة للمدرج، حركة/ساعة",
  "peak-hour movements today": "حركات ساعة الذروة اليوم",
  "Save the figures": "حفظ الأرقام",
  "What pays back first?": "ما الذي يسترد كلفته أولًا؟",
  "What is unpriced?": "ما غير المسعّر؟",
  "Cost a passenger": "الكلفة للراكب",
  "Turn unplanned closures into planned ones": "تحويل الإغلاقات غير المخططة إلى مخططة",
  Airfield: "الجانب الجوي",
  "{hours} h of unplanned closure in {days} days — {perYear} h a year — half of it made planned, at {rate}/h on the rate card":
    "{hours} ساعة من الإغلاق غير المخطط خلال {days} يومًا — {perYear} ساعة سنويًا — يُحوَّل نصفها إلى مخطط، بسعر {rate}/ساعة في بطاقة الأسعار",
  "Clear the overdue work": "إنجاز الأعمال المتأخرة",
  "work orders overdue": "أوامر العمل المتأخرة",
  orders: "أوامر",
  "{n} orders past due; each quarter late escalates the planned cost by {pct}% on the rate card":
    "عدد الأوامر المتأخرة: {n}؛ كل ربع سنة تأخير يرفع الكلفة المخططة بنسبة {pct}% وفق بطاقة الأسعار",
  "Faster priority-one repair": "إصلاح أسرع للأولوية الأولى",
  "Equipment availability program": "برنامج جاهزية المعدات",
  "Passenger flow at the worst queue": "تدفق الركاب عند أسوأ طابور",
  "Bags on time": "الأمتعة في موعدها",
  "On-time performance with the airlines": "الالتزام بالمواعيد مع شركات الطيران",
  "{gap} {unit} off target × {value} a point a year, entered":
    "{gap} {unit} بعيدًا عن المستهدف × {value} للنقطة سنويًا، قيمة مُدخَلة",
  "{gap} {unit} off target; the value of a point is not entered, so it is not priced":
    "{gap} {unit} بعيدًا عن المستهدف؛ قيمة النقطة غير مُدخَلة، لذا لم يُسعَّر",
  "Commercial revenue to plan": "الإيرادات التجارية وفق الخطة",
  Commercial: "التجاري",
  "non-aeronautical revenue a passenger": "الإيرادات غير الجوية للراكب",
  "{amount} under plan across {lines} in {days} days, annualised":
    "{amount} دون الخطة في {lines} خلال {days} يومًا، محسوبة على أساس سنوي",
  "no value entered": "لم تُدخَل قيمة",
  "operating cost a passenger": "التكلفة التشغيلية للراكب",
  "{n} passengers, {period}": "{n} راكب، {period}",
  "no passenger count": "لا يوجد عدد للركاب",
  "{amount} a passenger net": "{amount} صافيًا للراكب",
  "needs the finance figures": "يحتاج الأرقام المالية",
  "priority-one repair": "إصلاح الأولوية الأولى",
  "target {target} {unit}": "المستهدف {target} {unit}",
  "predictive precision": "دقة التنبؤ",
  "target {target}% — how often a prediction was right": "المستهدف {target}% — كم مرة صدق التنبؤ",
  "unplanned closure": "الإغلاق غير المخطط",
  "{n} unplanned closure on record|{n} unplanned closures on record":
    "لا إغلاقات غير مخططة مسجلة|إغلاق واحد غير مخطط مسجل|إغلاقان غير مخططين مسجلان|{n} إغلاقات غير مخططة مسجلة|{n} إغلاقًا غير مخطط مسجلًا|{n} إغلاق غير مخطط مسجل",
  "work overdue": "الأعمال المتأخرة",
  "nothing past due": "لا شيء متأخر",
  "priced initiatives a year": "المبادرات المسعّرة سنويًا",
  "{priced} of {n} initiatives priced": "{priced} من {n} مبادرات مسعّرة",
  "{site} earns {revenue} and spends {cost} a passenger; {n} initiatives are on the table, {priced} priced.":
    "يكسب {site} {revenue} وينفق {cost} للراكب؛ المبادرات المطروحة: {n}، المسعّر منها: {priced}.",
  "{site} has no per-passenger figures until the finance figures are entered; {n} initiatives are on the table, {priced} priced.":
    "لا توجد أرقام للراكب في {site} حتى تُدخَل الأرقام المالية؛ المبادرات المطروحة: {n}، المسعّر منها: {priced}.",
  "The best-paying is {name}: {value} a year, paying back in {months} months — {working}.":
    "الأعلى عائدًا: {name}: {value} سنويًا، ويسترد كلفته خلال {months} شهر — {working}.",
  "The best-paying is {name}: {value} a year — {working}.": "الأعلى عائدًا: {name}: {value} سنويًا — {working}.",
  "Nothing is priced yet.": "لم يُسعَّر شيء بعد.",
  "{n} initiative is unpriced because the value of a KPI point is not entered: {list}.":
    "مبادرة واحدة ({n}) غير مسعّرة لأن قيمة نقطة المؤشر غير مُدخَلة: {list}.",
  "{n} initiatives are unpriced because the value of a KPI point is not entered: {list}.":
    "مبادرات غير مسعّرة لأن قيمة نقطة المؤشر غير مُدخَلة ({n}): {list}.",
  "Every initiative carries a value.": "كل مبادرة لها قيمة.",
  "no finance figures": "لا توجد أرقام مالية",
  "the value of a KPI point is not entered for every off-target KPI":
    "قيمة نقطة المؤشر غير مُدخَلة لكل مؤشر بعيد عن المستهدف",
  "Where the operation leaks value, what each leak is worth, and the initiatives that close them, ranked by payback. The signals are the platform's — KPIs off target, overdue work, unplanned closures, revenue under plan. Each is priced only where a rate exists and says which; where none does, the value is left blank rather than guessed.":
    "أين تتسرب القيمة من التشغيل، وكم يساوي كل تسرب، والمبادرات التي تسده، مرتبة حسب مدة الاسترداد. الإشارات من المنصة — مؤشرات بعيدة عن المستهدف، وأعمال متأخرة، وإغلاقات غير مخططة، وإيرادات دون الخطة. ولا يُسعَّر أي منها إلا حيث يوجد سعر، مع ذكره؛ وحيث لا يوجد تُترك القيمة فارغة بدل تخمينها.",
  Initiatives: "المبادرات",
  "shortest payback first; unpriced ones last, with what would price them":
    "الأقصر استردادًا أولًا؛ وغير المسعّرة أخيرًا، مع ما يلزم لتسعيرها",
  initiative: "المبادرة",
  metric: "المقياس",
  cost: "الكلفة",
  payback: "الاسترداد",
  status: "الحالة",
  unpriced: "غير مسعّر",
  computed: "محسوب",
  starting: "ابتدائي",
  suggested: "مقترح",
  planned: "مخطط",
  running: "قيد التنفيذ",
  "{n} mo": "{n} شهر",
  "What pays back first? What is unpriced? What do we spend a passenger?":
    "ما الذي يسترد كلفته أولًا؟ ما غير المسعّر؟ كم ننفق على الراكب؟",
  "Your initiatives, and what a point of a KPI is worth": "مبادراتك، وكم تساوي نقطة المؤشر",
  "an hour of priority-one repair time": "ساعة من وقت إصلاح الأولوية الأولى",
  "one unit of major equipment out of service": "وحدة واحدة من المعدات الرئيسية خارج الخدمة",
  "a minute off the worst queue": "دقيقة أقل في أسوأ طابور",
  "a point of bags on time": "نقطة في الأمتعة الواصلة في موعدها",
  "a point of on-time departures": "نقطة في المغادرات في موعدها",
  "What a point is worth a year": "كم تساوي النقطة سنويًا",
  "entered by the executive; every off-target KPI with a value here becomes a priced initiative":
    "يُدخلها التنفيذي؛ وكل مؤشر بعيد عن المستهدف له قيمة هنا يصبح مبادرة مسعّرة",
  "value of {label}": "قيمة {label}",
  "Save the values": "حفظ القيم",
  "Add an initiative": "إضافة مبادرة",
  "ranked beside the platform's own, on the figures you give it":
    "تُرتَّب بجانب مبادرات المنصة، على الأرقام التي تعطيها",
  name: "الاسم",
  area: "المجال",
  "value a year": "القيمة سنويًا",
  "initiative name": "اسم المبادرة",
  "initiative area": "مجال المبادرة",
  "initiative value": "قيمة المبادرة",
  "initiative cost": "كلفة المبادرة",
  "initiative owner": "مسؤول المبادرة",
  "initiative status": "حالة المبادرة",
  "Add it": "إضافتها",
  "Where are we weakest?": "أين نحن الأضعف؟",
  "What is blank?": "ما الفارغ؟",
  "own metrics with a value": "مقاييسنا التي لها قيمة",
  "of {n}": "من {n}",
  "every metric has a value": "لكل مقياس قيمة",
  "peer values entered": "قيم النظراء المُدخَلة",
  "across {n} peers, from published sources": "عبر {n} من النظراء، من مصادر منشورة",
  "none yet — nothing is ranked until peer values are entered from published sources":
    "لا شيء بعد — لا يُرتَّب شيء حتى تُدخَل قيم النظراء من مصادر منشورة",
  "{set}: lead / trail / unranked": "{set}: متقدم / متأخر / غير مرتب",
  local: "محلي",
  "{lead} / {trail} / {unranked} of {n} metrics": "{lead} / {trail} / {unranked} من {n} مقياسًا",
  "{site} has a value for {known} of {n} benchmark metrics; {entered} peer values are entered, so {ranked} metrics rank regionally.":
    "لدى {site} قيمة لـ {known} من {n} من مقاييس المقارنة المعيارية؛ وقيم النظراء المُدخَلة: {entered}، لذا يُرتَّب إقليميًا من المقاييس: {ranked}.",
  "The weakest regional standing is {metric}: {rank} of {of}, {gap} {unit} behind {leader}.":
    "أضعف ترتيب إقليمي في {metric}: {rank} من {of}، بفارق {gap} {unit} خلف {leader}.",
  "the leader": "المتصدر",
  "The weakest regional standing is {metric}: {rank} of {of}, no leader to measure against.":
    "أضعف ترتيب إقليمي في {metric}: {rank} من {of}، ولا متصدر للقياس عليه.",
  "No metric ranks yet: enter peer values from the ACI and ASQ publications and each airport's sustainability report.":
    "لا يُرتَّب أي مقياس بعد: أدخل قيم النظراء من منشورات ACI وASQ وتقرير الاستدامة لكل مطار.",
  "Nothing here is estimated: a peer without a published figure stays blank, and the rank is only ever among those with one.":
    "لا شيء هنا مُقدَّر: النظير الذي ليس له رقم منشور يبقى فارغًا، والترتيب دائمًا بين من لهم رقم فقط.",
  "no peer values entered": "لم تُدخَل قيم للنظراء",
  "no own value for {metric}": "لا توجد قيمة لنا في {metric}",
  "Where the airport stands against the airports it is compared with, on every service a board asks about: locally in the Kingdom, regionally in the Gulf, and globally. The airport's own figures are its KPIs, its finance figures and its green programme. Peer figures are entered from published sources with the year and the source; the rank is only ever among the peers that have one, and a blank stays a blank.":
    "موقع المطار مقارنة بالمطارات التي يُقارن بها، في كل خدمة يسأل عنها مجلس الإدارة: محليًا في المملكة، وإقليميًا في الخليج، وعالميًا. أرقام المطار نفسه هي مؤشرات أدائه وأرقامه المالية وبرنامجه الأخضر. وتُدخَل أرقام النظراء من مصادر منشورة مع السنة والمصدر؛ والترتيب دائمًا بين النظراء الذين لهم رقم فقط، والفارغ يبقى فارغًا.",
  "Standing by metric": "الترتيب حسب المقياس",
  "own value, then the rank among peers with a value, the leader and the gap":
    "قيمتنا، ثم الترتيب بين النظراء الذين لهم قيمة، والمتصدر والفارق",
  own: "قيمتنا",
  rank: "الترتيب",
  leader: "المتصدر",
  "blank peers": "النظراء الفارغون",
  "no value": "لا قيمة",
  "{rank} of {of}": "{rank} من {of}",
  unranked: "غير مرتب",
  "{blank} of {total}": "{blank} من {total}",
  "On-time departures": "المغادرات في موعدها",
  "departures within 15 minutes of schedule": "المغادرات خلال 15 دقيقة من الموعد المجدول",
  "ASQ overall satisfaction": "الرضا العام في ASQ",
  "ACI's passenger survey score": "درجة استبيان الركاب لدى ACI",
  "Worst queue": "أسوأ طابور",
  "the longest wait at security or immigration": "أطول انتظار عند التفتيش الأمني أو الجوازات",
  "bags on the belt within the standard": "الأمتعة على السير ضمن المعيار",
  "how long a priority-one fault stays open": "المدة التي يبقى فيها عطل الأولوية الأولى مفتوحًا",
  "hours the runway was open over hours scheduled": "ساعات فتح المدرج مقسومة على الساعات المجدولة",
  "Revenue a passenger": "الإيرادات للراكب",
  "total revenue over passengers": "إجمالي الإيرادات مقسومًا على الركاب",
  "Non-aeronautical share": "حصة الإيرادات غير الجوية",
  "commercial revenue over total revenue": "الإيرادات التجارية مقسومة على إجمالي الإيرادات",
  "Operating cost a passenger": "التكلفة التشغيلية للراكب",
  "operating cost over passengers": "التكلفة التشغيلية مقسومة على الركاب",
  "Energy a passenger": "الطاقة للراكب",
  "electricity over passengers": "الكهرباء مقسومة على الركاب",
  "Carbon a passenger": "الكربون للراكب",
  "Scope 1 and 2 over passengers": "النطاقان 1 و2 مقسومين على الركاب",
  "ACI's ladder, 1 to 4+": "سُلَّم ACI، من 1 إلى +4",
  "Minimum turnaround": "أدنى زمن لخدمة الطائرة بين الرحلات",
  "the narrowbody turnaround the airport supports": "زمن خدمة الطائرة ضيقة البدن بين الرحلات الذي يدعمه المطار",
  "written from the figures; a connected model may argue and is checked against them, and may not supply a figure for any airport":
    "مكتوبة من الأرقام؛ يجوز لنموذج متصل أن يجادل ويُتحقق منه مقابلها، ولا يجوز له تقديم رقم لأي مطار",
  "Where are we weakest regionally? What leads globally? What is blank?":
    "أين نحن الأضعف إقليميًا؟ ما المتقدم عالميًا؟ ما الفارغ؟",
  "Enter a peer's published figure, or the airport's own for the metrics the platform does not hold":
    "أدخل رقمًا منشورًا لنظير، أو رقم المطار نفسه للمقاييس التي لا تحفظها المنصة",
  "What is blank": "ما الفارغ",
  "so the reader knows what the ranks leave out": "ليعرف القارئ ما تُغفله الترتيبات",
  "Peer and own values": "قيم النظراء وقيمنا",
  // prettier-ignore
  "{n} peer values entered; the airport's own ASQ score, ACA level and turnaround are entered as \"this airport\"": "قيم النظراء المُدخَلة: {n}؛ وتُدخَل درجة ASQ ومستوى ACA وزمن خدمة الطائرة للمطار نفسه باسم \"هذا المطار\"",
  airport: "المطار",
  year: "السنة",
  source: "المصدر",
  "peer airport": "المطار النظير",
  "this airport ({code})": "هذا المطار ({code})",
  "peer value": "قيمة النظير",
  "peer year": "سنة النظير",
  "peer source": "مصدر النظير",
  "ACI ASQ 2025; the airport's sustainability report": "ACI ASQ 2025؛ تقرير الاستدامة للمطار",
  "Enter the value": "إدخال القيمة",
  "on track": "على المسار",
  behind: "متأخر عن المسار",
  ahead: "متقدم على المسار",
  "no target": "لا مستهدف",
  "no data": "لا بيانات",
  "{kwh} kWh over {months}{annualised}{renewable} × {factor} {unit} ÷ 1000":
    "{kwh} kWh خلال {months}{annualised}{renewable} × {factor} {unit} ÷ 1000",
  ", annualised to {kwh}": "، محسوبة سنويًا إلى {kwh}",
  ", less {kwh} kWh on-site renewable": "، مطروحًا منها {kwh} kWh من الطاقة المتجددة في الموقع",
  "no metered electricity on the platform": "لا توجد قراءات عدادات كهرباء على المنصة",
  "no ground fuel on the platform; enter diesel and petrol litres per year for the fleet and generators — Scope 1 is blank until then":
    "لا يوجد وقود أرضي على المنصة؛ أدخل لترات الديزل والبنزين سنويًا للأسطول والمولدات — يبقى النطاق 1 فارغًا حتى ذلك الحين",
  "{diesel} L diesel × {dieselFactor} + {petrol} L petrol × {petrolFactor}, ÷ 1000":
    "{diesel} L ديزل × {dieselFactor} + {petrol} L بنزين × {petrolFactor}، ÷ 1000",
  "no fuel entered": "لم يُدخل أي وقود",
  "Scope 2 only — Scope 1 not entered": "النطاق 2 فقط — لم يُدخل النطاق 1",
  "Scope 1 + Scope 2": "النطاق 1 + النطاق 2",
  "entered estimate — never added to the total": "تقدير مُدخل — لا يُضاف إلى الإجمالي أبدًا",
  "not mapped": "غير محصور",
  "no passenger count on the platform; every per-passenger intensity is blank until it is entered":
    "لا يوجد عدد للركاب على المنصة؛ تبقى كل كثافة لكل راكب فارغة حتى يُدخل",
  "{tonnes} t × 1000 ÷ {pax} passengers": "{tonnes} t × 1000 ÷ {pax} راكب",
  "needs the inventory and passengers": "يحتاج إلى الحصر وعدد الركاب",
  "{kwh} kWh ÷ {pax}": "{kwh} kWh ÷ {pax}",
  "needs metered electricity and passengers": "يحتاج إلى قراءات عدادات الكهرباء وعدد الركاب",
  "the platform's own KPI": "مؤشر الأداء الرئيسي (KPI) الخاص بالمنصة",
  "annual kWh ÷ entered floor area": "kWh السنوية ÷ مساحة الأرضية المُدخلة",
  "no floor area": "لا توجد مساحة أرضية",
  "{m3} m³ × 1000 ÷ {pax}": "{m3} m³ × 1000 ÷ {pax}",
  "needs metered water and passengers": "يحتاج إلى قراءات عدادات المياه وعدد الركاب",
  "the platform's own KPI from the solar arrays": "مؤشر الأداء الرئيسي (KPI) الخاص بالمنصة من المصفوفات الشمسية",
  "entered generation ÷ annual electricity": "التوليد المُدخل ÷ الكهرباء السنوية",
  "no solar metered and none entered": "لا توجد قراءات للطاقة الشمسية ولم يُدخل شيء",
  "no baseline year, baseline tonnes, target year or reduction target entered; the trajectory and the plan need all four":
    "لم تُدخل سنة الأساس أو أطنان الأساس أو سنة المستهدف أو مستهدف الخفض؛ يحتاج المسار والخطة إلى الأربعة جميعًا",
  "fewer than twelve metered months: no trailing-twelve-month total yet":
    "أقل من اثني عشر شهرًا من القراءات: لا يوجد بعد إجمالي لآخر اثني عشر شهرًا",
  "trailing twelve months {tonnes} t; no target entered to compare against":
    "آخر اثني عشر شهرًا {tonnes} t؛ لم يُدخل مستهدف للمقارنة به",
  "trailing twelve months {tonnes} t against the target line's {target} t this month (baseline {baseline} t in {baselineYear}, −{pct}% by {targetYear}); least-squares trend not computable":
    "آخر اثني عشر شهرًا {tonnes} t مقابل {target} t على خط المستهدف هذا الشهر (الأساس {baseline} t في {baselineYear}، −{pct}% بحلول {targetYear})؛ اتجاه المربعات الصغرى غير قابل للحساب",
  "trailing twelve months {tonnes} t against the target line's {target} t this month (baseline {baseline} t in {baselineYear}, −{pct}% by {targetYear}); least-squares trend {trend} t/yr, reaching the target around {reach}":
    "آخر اثني عشر شهرًا {tonnes} t مقابل {target} t على خط المستهدف هذا الشهر (الأساس {baseline} t في {baselineYear}، −{pct}% بحلول {targetYear})؛ اتجاه المربعات الصغرى {trend} t/yr، ويبلغ المستهدف نحو {reach}",
  "trailing twelve months {tonnes} t against the target line's {target} t this month (baseline {baseline} t in {baselineYear}, −{pct}% by {targetYear}); least-squares trend {trend} t/yr, which never reaches it":
    "آخر اثني عشر شهرًا {tonnes} t مقابل {target} t على خط المستهدف هذا الشهر (الأساس {baseline} t في {baselineYear}، −{pct}% بحلول {targetYear})؛ اتجاه المربعات الصغرى {trend} t/yr، ولا يبلغ المستهدف أبدًا",
  "trailing twelve months {tonnes} t against the target line's {target} t this month (baseline {baseline} t in {baselineYear}, −{pct}% by {targetYear}); least-squares trend {trend} t/yr":
    "آخر اثني عشر شهرًا {tonnes} t مقابل {target} t على خط المستهدف هذا الشهر (الأساس {baseline} t في {baselineYear}، −{pct}% بحلول {targetYear})؛ اتجاه المربعات الصغرى {trend} t/yr",
  "{months} metered months and fuel entered": "عدد الأشهر ذات القراءات: {months}، والوقود مُدخل",
  "{months} of 12 metered months, fuel not entered": "{months} من 12 شهرًا من القراءات، والوقود غير مُدخل",
  "{months} of 12 metered months": "{months} من 12 شهرًا من القراءات",
  "connect or backfill the electricity meters to twelve months":
    "اربط عدادات الكهرباء أو استكمل بياناتها السابقة حتى اثني عشر شهرًا",
  "enter the year's fuel": "أدخل وقود السنة",
  "baseline {baselineYear}, −{pct}% by {targetYear}": "الأساس {baselineYear}، −{pct}% بحلول {targetYear}",
  "no target entered": "لم يُدخل مستهدف",
  "enter the baseline year and tonnes, the target year and the reduction":
    "أدخل سنة الأساس وأطنانها، وسنة المستهدف ونسبة الخفض",
  "{tonnes} t trailing against a baseline of {baseline} t":
    "{tonnes} t لآخر اثني عشر شهرًا مقابل أساس قدره {baseline} t",
  "needs the target and twelve metered months": "يحتاج إلى المستهدف واثني عشر شهرًا من القراءات",
  "the trailing year is not below the baseline yet — see the plan": "السنة الأخيرة ليست دون الأساس بعد — انظر الخطة",
  "needs the trajectory": "يحتاج إلى المسار",
  "{state} on a {pct}% target": "{state} على مستهدف {pct}%",
  "a science-based pathway needs at least a 30% reduction target and the trajectory on or ahead of it":
    "يحتاج المسار القائم على العلم إلى مستهدف خفض لا يقل عن 30% وإلى مسار عليه أو متقدم عليه",
  "entered as met": "مُدخل على أنه مستوفى",
  "no document tagged {tags} in the library": "لا توجد في المكتبة وثيقة موسومة بـ {tags}",
  " or ": " أو ",
  "add the document to the library with the tag, or record where it is held":
    "أضف الوثيقة إلى المكتبة مع الوسم، أو سجّل مكان حفظها",
  "not recorded": "غير مسجّل",
  "record the evidence — the verifier and date, the Scope 3 map, the retired credits":
    "سجّل الدليل — جهة التحقق والتاريخ، وحصر النطاق 3، والأرصدة المسحوبة",
  "this airport": "هذا المطار",
  "No peer has values yet. Enter each airport's ACA level and kgCO₂e per passenger from the ACA participant registry and its published sustainability report, with the year and the source; the ranking appears as values arrive.":
    "لا توجد قيم لأي نظير بعد. أدخل مستوى ACA لكل مطار و kgCO₂e لكل راكب من سجل المشاركين في ACA ومن تقرير الاستدامة المنشور له، مع السنة والمصدر؛ يظهر الترتيب مع وصول القيم.",
  "{n} of {total} peers have values entered; the rest are shown blank, not estimated.":
    "لدى {n} من {total} نظيرًا قيم مُدخلة؛ ويُعرض الباقي فارغًا دون تقدير.",
  "LED relamping": "الاستبدال بمصابيح LED",
  "{pct}% lighting share × {kwh} kWh × 0.5 saved × grid factor":
    "حصة الإنارة {pct}% × {kwh} kWh × 0.5 وفر × معامل الشبكة",
  "needs the lighting share of electricity": "يحتاج إلى حصة الإنارة من الكهرباء",
  "Solar PV expansion ({kwp} kWp at the card's rate)": "توسعة الطاقة الشمسية الكهروضوئية ({kwp} kWp بسعر البطاقة)",
  "{kwp} kWp × {yield} {unit} × grid factor": "{kwp} kWp × {yield} {unit} × معامل الشبكة",
  "HVAC setpoints and scheduling": "نقاط ضبط التكييف (HVAC) وجدولته",
  "{pct}% HVAC share × annual kWh × 0.12 saved × grid factor":
    "حصة التكييف (HVAC) {pct}% × kWh السنوية × 0.12 وفر × معامل الشبكة",
  "needs the HVAC share of electricity": "يحتاج إلى حصة التكييف (HVAC) من الكهرباء",
  "GPU and PCA at contact stands in place of APU":
    "وحدة الطاقة الأرضية (GPU) والهواء المكيّف المسبق (PCA) في مواقف الطائرات الملاصقة بدل APU",
  "{turnarounds} turnarounds × 60% on contact stands × {kg} kg":
    "{turnarounds} خدمة طائرة × 60% في المواقف الملاصقة × {kg} kg",
  "needs turnarounds per year": "يحتاج إلى عدد خدمات الطائرات سنويًا",
  "Fleet electrification": "كهربة الأسطول",
  "{pct}% of {diesel} L diesel × (diesel factor − replacement electricity)":
    "{pct}% من {diesel} L ديزل × (معامل الديزل − الكهرباء البديلة)",
  "needs the fleet's diesel share and the year's fuel": "يحتاج إلى حصة الأسطول من الديزل ووقود السنة",
  "Waste diversion to 60%": "تحويل النفايات إلى 60%",
  "{tonnes} t × (60% − {pct}% diverted) × landfill factor": "{tonnes} t × (60% − {pct}% محوّلة) × معامل المرادم",
  "needs waste tonnes and the diverted share": "يحتاج إلى أطنان النفايات والحصة المحوّلة",
  "Water recycling of 25% of consumption": "إعادة تدوير 25% من استهلاك المياه",
  "{m3} m³ × 25% × treatment factor": "{m3} m³ × 25% × معامل المعالجة",
  "No target to plan against yet.": "لا يوجد مستهدف يُخطط على أساسه بعد.",
  "The measures cover the {gap} t gap to the target, cheapest per tonne first.":
    "تغطي الإجراءات فجوة {gap} t إلى المستهدف، بدءًا بالأرخص للطن.",
  "The measures cover {covered} of the {gap} t gap; the rest needs measures not in the catalog, or a Scope 1 or grid change.":
    "تغطي الإجراءات {covered} من فجوة {gap} t؛ ويحتاج الباقي إلى إجراءات غير موجودة في القائمة، أو إلى تغيير في النطاق 1 أو في الشبكة.",
  "{n} metered month|{n} metered months":
    "لا أشهر من القراءات|شهر واحد من القراءات|شهران من القراءات|{n} أشهر من القراءات|{n} شهرًا من القراءات|{n} شهر من القراءات",
  "{site} stands at {level} with no tCO₂e Scope 1 and 2 on starting factors.":
    "يقف {site} عند {level} دون أي tCO₂e للنطاقين 1 و2 على معاملات مبدئية.",
  "{site} stands at {level} with no tCO₂e Scope 1 and 2.": "يقف {site} عند {level} دون أي tCO₂e للنطاقين 1 و2.",
  "{site} stands at {level} with {tonnes} tCO₂e Scope 1 and 2 on starting factors.":
    "يقف {site} عند {level} مع {tonnes} tCO₂e للنطاقين 1 و2 على معاملات مبدئية.",
  "{site} stands at {level} with {tonnes} tCO₂e Scope 1 and 2.":
    "يقف {site} عند {level} مع {tonnes} tCO₂e للنطاقين 1 و2.",
  "The trajectory is {state}: {working}.": "المسار {state}: {working}.",
  "The airport's carbon position three ways — the accreditation level it can evidence, its place on its own reduction trajectory, and its standing among peers — with the inventory every figure rests on, a plan of measures priced per tonne, and a LEED self-assessment beside it. Every factor is visible; a result on a starting factor rather than the airport's own says so in the tile.":
    "موقف المطار الكربوني من ثلاث زوايا — مستوى الاعتماد الذي يستطيع إثباته، وموقعه على مسار الخفض الخاص به، ومكانته بين نظرائه — مع الحصر الذي يستند إليه كل رقم، وخطة إجراءات مسعّرة للطن، وتقييم ذاتي لـ LEED إلى جانبها. كل معامل ظاهر؛ والنتيجة القائمة على معامل مبدئي لا على معامل المطار نفسه تذكر ذلك في البطاقة.",
  "the green program could not be built": "تعذّر بناء البرنامج الأخضر",
  "Demonstration meter series.": "سلسلة عدادات للعرض التوضيحي.",
  "The platform's consumption endpoint returned no readings, so the demonstration's annual energy and water are spread over twelve months. The inventory below shows the shape of the programme, not the airport's figures.":
    "لم تُرجع واجهة الاستهلاك في المنصة أي قراءات، لذا وُزّعت الطاقة والمياه السنوية للعرض التوضيحي على اثني عشر شهرًا. يُظهر الحصر أدناه شكل البرنامج، لا أرقام المطار.",
  "Scope 1 + 2": "النطاق 1 + 2",
  "Scope 2, electricity": "النطاق 2، الكهرباء",
  "Scope 1, fuel": "النطاق 1، الوقود",
  "carbon a passenger": "الكربون لكل راكب",
  "energy a passenger": "الطاقة لكل راكب",
  "renewable share": "حصة الطاقة المتجددة",
  accreditation: "الاعتماد",
  trajectory: "المسار",
  "{state} — {working}": "{state} — {working}",
  "LEED self-assessment": "التقييم الذاتي لـ LEED",
  "of {max}": "من {max}",
  "{level}; {needs} more for {next}": "{level}؛ ينقصه {needs} لبلوغ {next}",
  "not yet Certified; {n} points to go": "لم يبلغ Certified بعد؛ تبقّى {n} نقطة",
  "{level}; each requirement computed, documented or entered": "{level}؛ كل متطلب محسوب أو موثّق أو مُدخل",
  "No measure can be sized yet: enter the lighting and HVAC shares, turnarounds, the fleet's diesel share and the waste tonnes in the drawer.":
    "لا يمكن تقدير حجم أي إجراء بعد: أدخل حصتي الإنارة والتكييف (HVAC)، وخدمات الطائرات، وحصة الأسطول من الديزل، وأطنان النفايات في اللوحة المنسدلة.",
  "starting factor": "معامل مبدئي",
  "None: no month is more than 15% above the same month last year, or there is not yet a year to compare against.":
    "لا يوجد: لا شهر يزيد بأكثر من 15% على الشهر نفسه من العام الماضي، أو لا توجد بعد سنة للمقارنة بها.",
  "{meter} {month}: {value} against {lastYear} last year (+{pct}%)":
    "{meter} {month}: {value} مقابل {lastYear} في العام الماضي (+{pct}%)",
  electricity: "الكهرباء",
  water: "المياه",
  regional: "إقليمي",
  global: "عالمي",
  blank: "فارغ",
  "{note} {n} inputs are missing: {fields}.": "{note} المدخلات الناقصة ({n}): {fields}.",
  "What does the next ACA level need? Which measure is cheapest per tonne? Why did a month jump?":
    "ما الذي يحتاجه مستوى ACA التالي؟ أي إجراء هو الأرخص للطن؟ لماذا قفز شهر ما؟",
  "What the platform does not hold — passengers, fuel, waste, the baseline and the target, the factors":
    "ما لا تحتفظ به المنصة — الركاب، والوقود، والنفايات، والأساس والمستهدف، والمعاملات",
  "{total} of {max} points — {level}; {needs} more for {next} · LEED v4 O+M category maxima; check the rating system version before applying":
    "{total} من {max} نقطة — {level}؛ ينقصه {needs} لبلوغ {next} · الحدود القصوى لفئات LEED v4 O+M؛ تحقق من إصدار نظام التقييم قبل التقديم",
  "below Certified": "دون Certified",
  "{total} of {max} points — {level} · LEED v4 O+M category maxima; check the rating system version before applying":
    "{total} من {max} نقطة — {level} · الحدود القصوى لفئات LEED v4 O+M؛ تحقق من إصدار نظام التقييم قبل التقديم",
  "{category} (of {max})": "{category} (من {max})",
  "{category} points": "نقاط {category}",
  "Save the assessment": "حفظ التقييم",
  "Levels: {levels}. Most headroom: {headroom}.": "المستويات: {levels}. أكبر هامش متاح: {headroom}.",
  "{level} {min}+": "{level} {min}+",
  "{category} ({n} available)": "{category} ({n} متاحة)",
  "missing: {list}": "ناقص: {list}",
  "grid factor": "معامل الشبكة",
  "green program inputs": "مدخلات البرنامج الأخضر",
  "next level needs {n} thing|next level needs {n} things":
    "المستوى التالي لا يحتاج إلى شيء|المستوى التالي يحتاج إلى أمر واحد|المستوى التالي يحتاج إلى أمرين|المستوى التالي يحتاج إلى {n} أمور|المستوى التالي يحتاج إلى {n} أمرًا|المستوى التالي يحتاج إلى {n} أمر",
  "demonstration meter series": "سلسلة عدادات للعرض التوضيحي",
  "the platform's meters": "عدادات المنصة",
  "not accredited": "غير معتمد",
  "Level 1 · Mapping": "المستوى 1 · الحصر",
  "Level 2 · Reduction": "المستوى 2 · الخفض",
  "Level 3 · Optimisation": "المستوى 3 · التحسين الأمثل",
  "Level 3+ · Neutrality": "المستوى 3+ · الحياد",
  "Level 4 · Transformation": "المستوى 4 · التحول",
  "Level 4+ · Transition": "المستوى 4+ · الانتقال",
  "A Scope 1 and 2 carbon inventory for a full year": "حصر كربوني للنطاقين 1 و2 لسنة كاملة",
  "An environmental or carbon policy, signed": "سياسة بيئية أو كربونية موقّعة",
  "The inventory verified by a third party": "تحقق طرف ثالث من الحصر",
  "A reduction target with a baseline year": "مستهدف خفض مع سنة أساس",
  "A reduction in Scope 1 and 2 demonstrated against the baseline": "خفض مُثبت في النطاقين 1 و2 مقارنة بالأساس",
  "A carbon management plan": "خطة لإدارة الكربون",
  "Scope 3 emissions mapped — tenants, airlines, surface access, aircraft LTO":
    "حصر انبعاثات النطاق 3 — المستأجرون، وشركات الطيران، والوصول البري، ودورة الهبوط والإقلاع (LTO) للطائرات",
  "A stakeholder engagement plan with airlines and tenants": "خطة لإشراك أصحاب المصلحة مع شركات الطيران والمستأجرين",
  "Residual Scope 1 and 2 offset with retired credits on a recognised standard":
    "تعويض المتبقي من النطاقين 1 و2 بأرصدة مسحوبة وفق معيار معترف به",
  "Absolute reduction on a science-based pathway to net zero": "خفض مطلق على مسار قائم على العلم نحو الحياد الصفري",
  "A stakeholder partnership plan with commitments from third parties":
    "خطة شراكة مع أصحاب المصلحة تتضمن التزامات من أطراف ثالثة",
  "Compensation of residual emissions under Level 4+": "تعويض الانبعاثات المتبقية ضمن المستوى 4+",
  "Location and transportation": "الموقع والنقل",
  "Sustainable sites": "المواقع المستدامة",
  "Water efficiency": "كفاءة استخدام المياه",
  "Energy and atmosphere": "الطاقة والغلاف الجوي",
  "Materials and resources": "المواد والموارد",
  "Indoor environmental quality": "جودة البيئة الداخلية",
  Innovation: "الابتكار",
  "Regional priority": "الأولوية الإقليمية",
  "staff and passenger surface access — entered": "الوصول البري للموظفين والركاب — مُدخل",
  "site management, light pollution, rainwater — entered": "إدارة الموقع، والتلوث الضوئي، ومياه الأمطار — مُدخل",
  "the green programme's water intensity and recycling share":
    "كثافة استهلاك المياه وحصة إعادة التدوير في البرنامج الأخضر",
  "the green programme's energy intensity, renewable share and inventory":
    "كثافة الطاقة وحصة الطاقة المتجددة والحصر في البرنامج الأخضر",
  "waste tonnes and the diverted share": "أطنان النفايات والحصة المحوّلة",
  "air quality and thermal comfort — entered": "جودة الهواء والراحة الحرارية — مُدخل",
  entered: "مُدخل",
  Platinum: "Platinum (بلاتيني)",
  Gold: "Gold (ذهبي)",
  Silver: "Silver (فضي)",
  Certified: "Certified (معتمد)",
  "passengers a year": "الركاب سنويًا",
  "diesel, litres a year": "الديزل، لتر سنويًا",
  "petrol, litres a year": "البنزين، لتر سنويًا",
  "on-site renewable kWh a year": "kWh من الطاقة المتجددة في الموقع سنويًا",
  "waste tonnes a year": "أطنان النفايات سنويًا",
  "waste diverted %": "النفايات المحوّلة %",
  "floor area m²": "مساحة الأرضية m²",
  "baseline year": "سنة الأساس",
  "baseline tCO₂e": "tCO₂e الأساس",
  "target year": "سنة المستهدف",
  "reduction target %": "مستهدف الخفض %",
  "lighting share of electricity %": "حصة الإنارة من الكهرباء %",
  "HVAC share of electricity %": "حصة التكييف (HVAC) من الكهرباء %",
  "turnarounds a year": "خدمات الطائرات سنويًا",
  "fleet share of diesel %": "حصة الأسطول من الديزل %",
  "Scope 3 estimate tCO₂e": "تقدير النطاق 3 tCO₂e",
  "grid factor kgCO₂e/kWh (the supplier's)": "معامل الشبكة kgCO₂e/kWh (معامل المورّد)",
  "The next ACA level": "مستوى ACA التالي",
  "Cheapest per tonne": "الأرخص للطن",
  "Airport Carbon Accreditation": "اعتماد الكربون للمطارات (ACA)",
  "The plan": "الخطة",
  Anomalies: "الحالات الشاذة",
  "a month more than 15% above the same month last year, on any meter":
    "شهر يزيد بأكثر من 15% على الشهر نفسه من العام الماضي، على أي عداد",
  Peers: "النظراء",
  "a connected model may explain the inventory and the plan, and is checked figure by figure":
    "يمكن لنموذج متصل أن يشرح الحصر والخطة، ويُتحقق منه رقمًا برقم",
  "Entered quantities and factors": "الكميات والمعاملات المُدخلة",
  "every quantity the engine needs is present": "كل كمية يحتاجها المحرك موجودة",
};
export default ar;
